import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Navbar from "../../navbar/Navbar";
import LinkToRegistration from "../../property/component/LinkToRegistration";
import Stepper from "../../Stepper/component/Stepper";
import partydetailsimg from "../../../Images/partydetailsimg.png";
import { v4 as uuidv4 } from "uuid";
import {
  completeStep,
  nextStep,
  goToStep,
  prevStep,
  resetStep,
} from "../../Stepper/stepperSlice";
import DatePicker from "react-datepicker";

import {
  fetchDistrictData,
  fetchSROData,
  selectPdEId,
} from "../../property/propertySlice";

import {
  fetchLoggedInUserInfoAsync,
  selectUserEvaluations,
  selectLatestEvaluation,
  selectPDEInfo,
  fetchPDEInfoAsync,
} from "../../user/userSlice";
import {
  fetchDistrictDataAsync,
  fetchIdProofDataAsync,
  fetchStateDataAsync,
  selectDistrictOptions,
  selectIdProofOptions,
  selectisMobileVerified,
  selectLoggedInUser,
  selectStateOptions,
  setisMobileVerified,
} from "../../auth/authSlice";
import { useForm } from "react-hook-form";
import {
  checkAadhaarAsync,
  clearAadhaarDetails,
  fetchAadhaarDetailsAsync,
  selectAadhaarDetails,
  selectIsOTPVerified,
  setOTP,
} from "../../property/AadhaarDetailsSlice";
import AadhaarOTPModal from "../../modal/AadhaarOTPModal";
import RegistrationSuccessModal from "../../modal/RegistrationSuccessModal";
import Datatable from "../../dashboard/component/Datatable";
import {
  translateTextAsync,
  selectTranslatedText,
  clearTranslation,
} from "../../Translate/TranslateSlice";
import {
  fetchGender,
  fetchIDTypeData,
  fetchOccupationData,
  fetchRelationData,
  InsertPartyDetails,
  InsertPartyDetailsPaperLess,
  ModifyPartyDetails,
  ModifyPartyDetailsPaperless,
  resetAdhaarEkyc,
  resetConfirmed,
  resetPartySignUpDetails,
  selectAdhaarEkyc,
  selectConfirmed,
  selectFirstParty,
  selectModParty,
  selectPartySignUpDetails,
  selectSecondParty,
  selectWitness,
  setConfirmedNo,
  setConfirmedYes,
  setFirstPartyDetails,
  setSecondPartyDetails,
  setWitnessDetails,
  updatePartyDetails,
} from "../PartyDetailSlice";
import {
  selectIsModifying,
  selectProcedureMod,
  setModifying,
} from "../../Modify/ModifySlice";
import {
  modifyAppointmentType,
  updateAppointmentType,
} from "../../modal/modalSlices/ProcedureSlice";
import EkycModal from "../../modal/EkycModal";
import MobileModal from "../../modal/MobileModal";
import PartySignUpModal from "../../modal/PartySignUpModal";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import API_BASE_URL from "../../BaseURL/baseURL";
import axiosInstance from "../../BaseURL/axiosInstance";

const PartyDetails = () => {
  const dispatch = useDispatch();
  const idProofOptions = useSelector(selectIdProofOptions);

  const evaluations = useSelector(selectUserEvaluations);
  const latestEvaluation = useSelector(selectLatestEvaluation);
  //console.log("latest evaluation =" + latestEvaluation);
  const {
    register,
    formState: { errors },
  } = useForm();

  const error = useSelector((state) => state.property.error);
  const pdeInfo = useSelector(selectPDEInfo);
  const pdeData = pdeInfo?.pdeData[0];
  //console.log("pdeData inEvaluation:", pdeData);

  const user = useSelector(selectLoggedInUser);

  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState("firstParty");
  const [identificationType, setIdentificationType] = useState("");

  const appointmentType = useSelector(
    (state) => state.Procedure.appointmentType
  );

  //console.log("Procedure Type:", appointmentType);
  const VP = (appointmentType) => {
    if (appointmentType === "V" || appointmentType === "VI") {
      return "VIRTUAL PROCEDURE";
    } else if (appointmentType === "P" || appointmentType === "PH") {
      return "PHYSICAL PROCEDURE";
    } else if (appointmentType === "L") {
      return "PAPERLESS PROCEDURE";
    } else {
      return "";
    }
  };
  useEffect(() => {
    if (pdeData?.deedcode === "04") {
      const data = [
        {
          id_No: "",
          id_Type_Code: "",
          name_Eng: "",
          name_Hin: "",
          relation: "",
          father_Name_Eng: "",
          father_Name_Hin: "",
          gender: "",
          gendeR_CODE: "",
          vtc: "",
          paN_Form60: "",
          paN_no: "",
          form60: "",
          occu_Code: "",
          mobile_No: "",
          dob: "",
          country: "",
          house_no: "",
          landmark: "",
          street: "",
          state: "",
          district: "",
          pincode: "",
          photo: "",
        },
      ];
      dispatch(setSecondPartyDetails(data));
    }
  }, [pdeInfo, dispatch]);

  useEffect(() => {
    dispatch(fetchLoggedInUserInfoAsync(user.email));
  }, [dispatch]);
  useEffect(() => {
    dispatch(fetchIdProofDataAsync());
  }, [dispatch]);

  useEffect(() => {
    if (latestEvaluation) {
      //console.log("Latest Evaluation:", latestEvaluation);
    }
  }, [latestEvaluation]);

  useEffect(() => {
    if (evaluations) {
      //console.log("Evaluation:", evaluations);
    }
  }, [evaluations]);

  const renderForm = () => {
    if (!appointmentType) {
      return (
        <p className="text-center text-gray-500">
          Please select an appointment type to proceed.
        </p>
      );
    }

    switch (activeTab) {
      case "firstParty":
        return <FirstPartyForm onNext={handleNext} />;
      case "secondParty":
        return <SecondPartyForm onNext={handleNext} />;
      case "witness":
        return <WitnessForm onNext={handleNext} />;
      default:
        return <FirstPartyForm onNext={handleNext} />;
    }
  };

  const handleNext = () => {
    if (activeTab === "firstParty" && pdeData?.deedcode !== "04") {
      setActiveTab("secondParty");
    } else if (activeTab === "firstParty" && pdeData?.deedcode === "04") {
      setActiveTab("witness");
    } else if (activeTab === "secondParty") {
      setActiveTab("witness");
    }
    dispatch(clearTranslation());
  };

  return (
    <>
      <Navbar />
      <LinkToRegistration />
      <div className="flex flex-grow">
        <div className="w-1/5 bg-white py-4 flex justify-center">
          <Stepper />
        </div>
        <div className="w-0.5 border-none bg-neutral-400"></div>
        <div className="w-4/5 flex justify-center">
          <div className="w-full bg-white rounded-lg">
            <div className="text-red-600 text-sm m-2 grid grid-cols-1 gap-2">
              {/* <p>
                Important Note : Please Download the Hindi Typing Tool
                <a href="#" className="text-blue-500 ml-4">
                  Download
                </a>
              </p> */}
              <p>Important Note : Enter Date of Birth in Form 60 Field</p>
              {/* <p>
                Important Note : To Convert English Text to Hindi Text Please
                Press Space after typing word
              </p> */}
              <p className="text-black font-semibold">
                {VP(appointmentType) || ""}
              </p>
            </div>

            <div className="grid gap-0.5 justify-start grid-cols-11 items-center mx-3">
              <button
                onClick={() => setActiveTab("firstParty")}
                className={`col-span-3 ${
                  activeTab === "firstParty"
                    ? "bg-blue-500 text-white"
                    : "bg-gray-100 text-black"
                }`}
              >
                First Party Detail
              </button>
              {pdeData?.deedcode !== "04" && (
                <button
                  onClick={() => setActiveTab("secondParty")}
                  className={`col-span-3 ${
                    activeTab === "secondParty"
                      ? "bg-blue-500 text-white"
                      : "bg-gray-100 text-black"
                  }`}
                >
                  Second Party Detail
                </button>
              )}
              <button
                onClick={() => setActiveTab("witness")}
                className={`col-span-3 ${
                  activeTab === "witness"
                    ? "bg-blue-500 text-white"
                    : "bg-gray-100 text-black"
                }`}
              >
                Witness Detail
              </button>
            </div>
            <div className="border-2 border-gray-400 m-3 mt-0">
              {/* <div className=" text-red-600 text-sm font-semibold m-2 grid grid-cols-1 gap-2">
                IN CASE OF NON AVAILABILITY OF PAN CARD, FORM 60 (Enter date of
                birth) IS MANDATORY FOR TRANSACTIONS MORE THAN 5 LAKHS
              </div> */}
              {renderForm()}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const FirstPartyForm = ({ onNext }) => {
  const { relationData, occupationData, idTypeData, genderData } = useSelector(
    (state) => state.PartyDetail
  );

  const appointmentType = useSelector(
    (state) => state.Procedure.appointmentType
  );

  const adhaarEkyc = useSelector(selectAdhaarEkyc);

  const pde = useSelector(selectPdEId);
  const pdeInfo = useSelector(selectPDEInfo);
  const translatedText = useSelector(selectTranslatedText);
  // const aadhaarDetails = useSelector(selectAadhaarDetails);
  // //console.log("aadhaar details:", aadhaarDetails);
  const [identificationType, setIdentificationType] = useState("");
  const [IDNo, setIDNo] = useState("");
  const [idName, setidName] = useState("");
  const dispatch = useDispatch();
  const [showOtpForm, setShowOtpForm] = useState(false);
  const [Name, setName] = useState("");
  const [HindiName, setHindiName] = useState("");
  const [relation, setRelation] = useState("");
  const [Relative, setRelative] = useState("");
  const [RelativeHindi, setRelativeHindi] = useState("");
  const [Gender, setGender] = useState("");
  const [GenderName, setGenderName] = useState("");
  const [Occupation, setOccupation] = useState("");
  const [occupationName, setoccupationName] = useState("");
  const [Mobile, setMobile] = useState("");
  const [Email, setEmail] = useState("");
  const [Photo, setPhoto] = useState("");
  const [isPhotoVisible, setIsPhotoVisible] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [form60Date, setForm60Date] = useState(null); // For First & Second Party only
  // const [form60 ,setform60] = useState("")
  const [HouseNo, setHouseNo] = useState("");
  const [Locality, setLocality] = useState("");
  const [Area, setArea] = useState("");
  const [State, setState] = useState("");
  const [stateName, setStateName] = useState("");
  //console.log(State);
  const [district, setDistrict] = useState("");
  const [districtName, setDistrictName] = useState("");
  const [Pincode, setPincode] = useState("");
  const [datatableEntries, setDatatableEntries] = useState([]);
  const [paN_Form60, setpaN_Form60] = useState("PAN");
  const [paN_no, setPanNo] = useState("");
  const [POADate, setPOADate] = useState("");
  const [POAYear, setPOAYear] = useState("");
  const [Office, setOffice] = useState("");
  const [DocumentNo, setDocumentNo] = useState("");
  const [Registration_For, setRegistration_For] = useState("");
  const [Reg_Code, setReg_Code] = useState("");
  const stateOptions = useSelector(selectStateOptions);
  const districtOptions = useSelector(selectDistrictOptions);
  const [isEditing, setIsEditing] = useState(false);
  const [editId, setEditId] = useState(null);
  const isModifying = useSelector(selectIsModifying);
  const [error, setError] = useState("");
  const [confirmed, setConfirmed] = useState(null);
  const [isSignUpModalOpen, setIsSignUpModalOpen] = useState(false);
  const [isMobileModalOpen, setIsMobileModalOpen] = useState(false);
  const PartySignUpDetails = useSelector(selectPartySignUpDetails);
  const [isEditMode, setIsEditMode] = useState(false);
  const confirmedSlice = useSelector(selectConfirmed);
  const [isPartySignUpModify, setIsPartySignUpModify] = useState(false);
  const [reEkyc, setReEkyc] = useState(false);
  const isOTPVerified = useSelector(selectIsOTPVerified);
  const isMobileVerified = useSelector(selectisMobileVerified);
  // const [userDataFetched, setUserDataFetched] = useState(false);

  useEffect(() => {
    if (confirmedSlice === null) {
      setConfirmed(confirmedSlice);
    }
  }, [confirmedSlice]);

  useEffect(() => {
    if (
      PartySignUpDetails &&
      adhaarEkyc === "N" &&
      PartySignUpDetails[0]?.identificationType !== "04" &&
      (appointmentType === "V" || appointmentType === "VI") &&
      confirmed !== null &&
      isOTPVerified === false
    ) {
      setIsMobileModalOpen(false);
      setIsPartySignUpModify(true);
      setIsSignUpModalOpen(true);
      dispatch(clearAadhaarDetails());
      setisMobileVerified(false);
    }
  }, [PartySignUpDetails, appointmentType, confirmed, isOTPVerified]);

  useEffect(() => {
    if (
      PartySignUpDetails &&
      PartySignUpDetails[0]?.identificationType === "04" &&
      adhaarEkyc === "N" &&
      (appointmentType === "V" || appointmentType === "VI")
    ) {
      setIsMobileModalOpen(false);
      setIsPartySignUpModify(true);
      setIsSignUpModalOpen(true);
      // dispatch(resetPartySignUpDetails());
      // dispatch(setConfirmedNo());
      dispatch(clearAadhaarDetails());
      // dispatch(resetConfirmed());
      setisMobileVerified(false);
    }
  }, [PartySignUpDetails, appointmentType, confirmed, isMobileVerified]);

  useEffect(() => {
    dispatch(fetchStateDataAsync());
    dispatch(fetchGender());
    dispatch(fetchIDTypeData());
    dispatch(fetchOccupationData());
  }, [dispatch]);

  const handleStateChange = (e) => {
    const stateId = e.target.value; // This is a string from the select input
    setState(stateId); // Set the state ID

    // Ensure that stateOptions is an array before proceeding
    if (Array.isArray(stateOptions)) {
      const selectedState = stateOptions.find(
        (option) => option.stateID.toString() === stateId // Convert stateID to string for comparison
      );

      //console.log("State ID from select:", stateId);
      //console.log("Selected State:", selectedState);

      setStateName(selectedState ? selectedState.stateName : ""); // Set the state name

      if (selectedState) {
        dispatch(fetchDistrictDataAsync(stateId)); // Fetch district data if a state is selected
      }
    } else {
      console.error("stateOptions is not an array or is undefined");
    }
  };

  const handleDistrictChange = (e) => {
    const districtID = e.target.value; // This is a string from the select input
    setDistrict(districtID); // Set the state ID

    // Ensure that stateOptions is an array before proceeding
    if (Array.isArray(districtOptions)) {
      const selectedDistrict = districtOptions.find(
        (option) => option.districtID.toString() === districtID
      );
      setDistrictName(selectedDistrict ? selectedDistrict.districtName : "");
    } else {
      console.error("stateOptions is not an array or is undefined");
    }
  };

  const handleGenderChange = (e) => {
    const selectedGenderCode = e.target.value;
    setGender(selectedGenderCode); // Set the gender code
    const selectedGender = genderData.find(
      (option) => option.gendeR_CODE === selectedGenderCode
    );
    setGenderName(selectedGender ? selectedGender.gender : ""); // Set the gender name
  };

  useEffect(() => {
    // const storedEntries = localStorage.getItem("datatableEntries");
    const storedEntries = sessionStorage.getItem("datatableEntries");
    if (storedEntries) {
      setDatatableEntries(JSON.parse(storedEntries));
    }
  }, []);

  useEffect(() => {
    if (pde || PartySignUpDetails) {
      dispatch(fetchPDEInfoAsync(pde));
      dispatch(fetchRelationData());
      dispatch(fetchIDTypeData());
    }
  }, [dispatch, pde, PartySignUpDetails]);

  useEffect(() => {
    if (
      PartySignUpDetails?.length &&
      ((appointmentType === "V" && adhaarEkyc === "Y") ||
        appointmentType === "P" ||
        appointmentType === "L")
      // (isMobileVerified === true || isMobileVerified === false)
    ) {
      const firstDetail = PartySignUpDetails[0];
      setIdentificationType(firstDetail.identificationType || "");
      setIDNo(firstDetail.identificationNumber || "");
      setName(firstDetail.name || "");
      setRelation(firstDetail.relationShip);
      setRelative(firstDetail.father_Mother_guardian_Name || "");
      setGender(firstDetail.addGender || "");
      setMobile(firstDetail.mobileNo || "");
      setHouseNo(firstDetail.addHousenoFlat || "");
      setLocality(firstDetail.addBuilding_Landmark || "");
      setArea(firstDetail.addAreaLocality || "");
      setState(firstDetail.addState || "");
      setDistrict(firstDetail.addDistrict || "");
      setPincode(firstDetail.addPinCode || "");
      setEmail(firstDetail.email || "");
      setPhoto(firstDetail.photo || "");

      // if (appointmentType === "L") {
      //   setPOADate(firstDetail.poaDate || "");
      //   setPOAYear(firstDetail.poaYear || "");
      //   setOffice(firstDetail.office || "");
      //   setDocumentNo(firstDetail.documentNo || "");
      //   setRegistration_For(firstDetail.registration_For || "");
      //   setReg_Code(firstDetail.reg_Code || "");
      // }
      setPOADate(firstDetail.poaDate || "");
      setPOAYear(firstDetail.poaYear || "");
      setOffice(firstDetail.office || "");
      setDocumentNo(firstDetail.documentNo || "");
      setRegistration_For(firstDetail.registration_For || "");
      setReg_Code(firstDetail.reg_Code || "");

      // Fetch state details
      const selectedState = stateOptions.find(
        (option) =>
          option.stateID.toString() === firstDetail.addState.toString()
      );

      //console.log("State ID from select:", firstDetail.addState);
      //console.log("Selected State:", selectedState);

      setStateName(selectedState ? selectedState.stateName : "");
      if (selectedState) {
        //console.log("Fetching districts for stateID:", selectedState.stateID);
        dispatch(fetchDistrictDataAsync(selectedState.stateID));
        // Set gender and gender name
        const genderMap = {
          "01": "Male",
          "02": "Female",
          "03": "Transgender",
        };

        const genderName = genderMap[firstDetail.addGender] || "";
        setGender(firstDetail.addGender || "");
        setGenderName(genderName);

        // Translate name and relative name
        if (firstDetail.name) {
          dispatch(
            translateTextAsync({
              text: firstDetail.name,
              source: "en",
              target: "hi",
              field: "Name",
            })
          );
        }
        if (firstDetail.father_Mother_guardian_Name) {
          dispatch(
            translateTextAsync({
              text: firstDetail.father_Mother_guardian_Name,
              source: "en",
              target: "hi",
              field: "Relative",
            })
          );
        }
      }
    }
  }, [PartySignUpDetails, stateOptions, dispatch]);

  useEffect(() => {
    if (districtOptions.length > 0 && PartySignUpDetails?.length) {
      const selectedDistrict = districtOptions.find(
        (option) =>
          option.districtID.toString() ===
          PartySignUpDetails[0].addDistrict.toString()
      );

      // console.log(
      //   "District ID from select:",
      //   PartySignUpDetails[0].addDistrict
      // );
      // console.log("Selected District:", selectedDistrict);

      setDistrictName(selectedDistrict ? selectedDistrict.districtName : "");
    }
  }, [districtOptions, PartySignUpDetails]);

  useEffect(() => {
    if (translatedText) {
      setHindiName(translatedText.Name || "");
      setRelativeHindi(translatedText.Relative || "");
    }
  }, [translatedText]);

  const handelReEkyc = () => {
    setReEkyc(true);
    setIsPartySignUpModify(true);
    setIsSignUpModalOpen(true);
  };

  const validateInputs = () => {
    const mobileRegex = /^[0-9]{10}$/; // Regex for a 10-digit mobile number
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/; // Regex for PAN number format
    // const emailRegex = /^[a-zA-Z0-9]+@(?:[a-zA-Z0-9]+\.)+[A-Za-z]+$/;
    const emailRegex =
      /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    if (appointmentType === "L" && !Registration_For) {
      toast.error("Please select a 'Registration For' option.");
      return false;
    }
    if (appointmentType === "L" && Registration_For === "POA") {
      if (!POADate || !Office || !DocumentNo || !POAYear) {
        toast.error("Please fill all POA details.");
        return false;
      }
    }

    if (!mobileRegex.test(Mobile)) {
      toast.error("Please enter a valid mobile number (10 digits).");
      return false;
    }

    if (!emailRegex.test(Email)) {
      toast.error("Please enter a valid Email");
      return false;
    }

    if (paN_Form60 === "PAN" && !panRegex.test(paN_no)) {
      toast.error("Please enter a valid PAN number.");
      return false;
    }

    if (!Occupation) {
      toast.error("Please select an occupation.");
      return false;
    }

    return true;
  };

  const resetFields = () => {
    setName("");
    setHindiName("");
    setRelation("");
    setRelative("");
    setRelativeHindi("");
    setGender("");
    setGenderName("");
    setOccupation("");
    setoccupationName("");
    setMobile("");
    setSelectedDate("");
    setHouseNo("");
    setLocality("");
    setArea("");
    setState("");
    setStateName("");
    setDistrict("");
    setDistrictName("");
    setPincode("");
    setPanNo("");
    setEmail("");
    setPOADate("");
    setPOAYear("");
    setOffice("");
    setDocumentNo("");
    setRegistration_For("");
    setReg_Code("");
  };

  const handleSave = (e) => {
    const pattern = regexPatterns[identificationType];
    e.preventDefault(); // Prevent default form submission
    if (!validateInputs()) {
      return;
    } // Check inputs before proceeding
    if (pattern && !pattern.test(IDNo)) {
      setError("Invalid ID No. for " + idName);
      return; // Prevent form submission
    }

    const newData = {
      id: isEditing ? editId : uuidv4(),
      id_No: IDNo,
      idName: PartySignUpDetails
        ? filteredIdTypeData.find(
            (option) => option.iD_CODE === identificationType
          )?.id || ""
        : idName, // Conditionally set idName
      id_Type_Code: identificationType,
      name_Eng: Name,
      name_Hin: HindiName,
      relation: relation,
      father_Name_Eng: Relative,
      father_Name_Hin: RelativeHindi,
      gender: GenderName,
      gendeR_CODE: Gender,
      vtc: "",
      paN_Form60: paN_Form60,
      paN_no: paN_no,
      form60: form60Date ? form60Date.toISOString().split("T")[0] : null,
      occu_Code: Occupation,
      occupation: occupationName,
      mobile_No: Mobile,
      email: Email,
      dob: null,
      country: "India",
      house_no: HouseNo,
      landmark: Locality,
      street: Area,
      state: State,
      stateName: stateName,
      district: district,
      districtName: districtName,
      pincode: Pincode,
      photo: Photo || null,
      // ...(appointmentType === "L" && {
      //   POADate: POADate,
      //   Office: Office,
      //   DocumentNo: DocumentNo,
      //   POAYear: POAYear,
      //   Reg_Code: Reg_Code,
      //   Registration_For: Registration_For,
      // }),
      POADate: POADate,
      Office: Office,
      DocumentNo: DocumentNo,
      POAYear: POAYear,
      Reg_Code: Reg_Code,
      Registration_For: Registration_For,
    };

    //console.log("Before update:");
    //console.log("datatableEntries:", datatableEntries);
    //console.log("isEditing:", isEditing);
    //console.log("editId:", editId);
    //console.log("newData:", newData);

    const updatedEntries = isEditing
      ? datatableEntries.map((entry) => (entry.id === editId ? newData : entry))
      : [...datatableEntries, newData];

    //console.log("After update:");
    //console.log("updatedEntries:", updatedEntries);
    setDatatableEntries(updatedEntries);
    dispatch(setFirstPartyDetails(updatedEntries));
    sessionStorage.setItem("datatableEntries", JSON.stringify(updatedEntries));

    // Clear form fields after saving
    setIDNo("");
    setIdentificationType("");
    setidName("");
    setEditId(null);
    setIsEditing(false);
    dispatch(clearAadhaarDetails());
    dispatch(resetPartySignUpDetails());
    //console.log(PartySignUpDetails);
    dispatch(setisMobileVerified(false));
    setConfirmed(null);
    dispatch(clearTranslation());
    dispatch(resetConfirmed());
    resetFields();
    setIsEditMode(false);
    setIsPartySignUpModify(false);
  };

  const handleDelete = (id) => {
    //console.log("Deleting item with ID:", id);

    // Ensure `id` is a string or match the format of `datatableEntries` ids
    const idToDelete = id.id || id; // Use `id.id` if `id` is an object

    // Filter out the entry with the matching `id`
    const updatedEntries = datatableEntries.filter(
      (entry) => entry.id !== idToDelete
    );

    //console.log("Updated Entries after delete:", updatedEntries);

    setDatatableEntries(updatedEntries);
    dispatch(setFirstPartyDetails(updatedEntries));
    dispatch(clearAadhaarDetails());
    dispatch(clearTranslation());
    // localStorage.setItem("datatableEntries", JSON.stringify(updatedEntries));
    sessionStorage.setItem("datatableEntries", JSON.stringify(updatedEntries));
  };

  const handleEdit = (id) => {
    setIsEditMode(true);
    // Find the entry to edit based on the ID provided
    const entryToEdit = datatableEntries.find((entry) => entry.id === id);

    //console.log("Editing entry with ID:", id);
    //console.log("Current DataTable Entries:", datatableEntries);

    // Log details of each entry for debugging
    datatableEntries.forEach((entry) => {
      //console.log("Entry keys:", Object.keys(entry)); // Log the keys of the entry
      //console.log("Entry values:", entry); // Log the entire entry object
    });

    // Check if the entry was found
    //console.log("Entry to edit:", entryToEdit);
    if (entryToEdit) {
      // Populate form fields with the entry data
      setIDNo(entryToEdit.id_No);
      setidName(entryToEdit.idName);
      setIdentificationType(entryToEdit.id_Type_Code);
      setName(entryToEdit.name_Eng);
      setHindiName(entryToEdit.name_Hin);
      setRelation(entryToEdit.relation);
      setRelative(entryToEdit.father_Name_Eng);
      setRelativeHindi(entryToEdit.father_Name_Hin);
      setGender(entryToEdit.gendeR_CODE);
      setGenderName(entryToEdit.gender);
      setOccupation(entryToEdit.occu_Code);
      setoccupationName(entryToEdit.occupation);
      setMobile(entryToEdit.mobile_No);
      setEmail(entryToEdit.email);
      setSelectedDate(entryToEdit.dob ? new Date(entryToEdit.dob) : null); // Convert to Date object if dob is not null
      setHouseNo(entryToEdit.house_no);
      setForm60Date(entryToEdit.form60 ? new Date(entryToEdit.form60) : null); // ✅ correct

      setLocality(entryToEdit.landmark);
      setArea(entryToEdit.street);
      setState(entryToEdit.state);
      setStateName(entryToEdit.stateName);
      setDistrict(entryToEdit.district);
      setDistrictName(entryToEdit.districtName);
      setPincode(entryToEdit.pincode);
      setPanNo(entryToEdit.paN_no);
      setpaN_Form60(entryToEdit.paN_Form60);

      // if (appointmentType === "L") {
      //   setPOADate(entryToEdit.POADate);
      //   setOffice(entryToEdit.Office);
      //   setDocumentNo(entryToEdit.DocumentNo);
      //   setPOAYear(entryToEdit.POAYear);
      //   setReg_Code(entryToEdit.Reg_Code);
      //   setRegistration_For(entryToEdit.Registration_For);
      // }
      setPOADate(entryToEdit.POADate);
      setOffice(entryToEdit.Office);
      setDocumentNo(entryToEdit.DocumentNo);
      setPOAYear(entryToEdit.POAYear);
      setReg_Code(entryToEdit.Reg_Code);
      setRegistration_For(entryToEdit.Registration_For);

      // Set edit mode
      setEditId(entryToEdit.id); // Assuming id_No is the unique identifier
      setIsEditing(true);
    } else {
      console.error("Entry not found for the given ID:", id);
    }
  };

  // const handleNameChange = (e) => {
  //   const name = e.target.value;
  //   setName(name);
  //   if (name) {
  //     dispatch(
  //       translateTextAsync({
  //         text: name,
  //         source: "en",
  //         target: "hi",
  //         field: "Name",
  //       })
  //     );
  //   } else {
  //     setHindiName("");
  //   }
  // };

  const handleNameChange = (e) => {
    const raw = e.target.value;
    const cleanedName = raw.replace(/\s+/g, " ").trim();
    setName(cleanedName);

    if (cleanedName) {
      dispatch(
        translateTextAsync({
          text: cleanedName,
          source: "en",
          target: "hi",
          field: "Name",
        })
      );
    } else {
      setHindiName("");
    }
  };

  const handleRelativeChange = (e) => {
    const relative = e.target.value;
    setRelative(relative);
    if (relative) {
      dispatch(
        translateTextAsync({
          text: relative,
          source: "en",
          target: "hi",
          field: "Relative",
        })
      );
    } else {
      setRelativeHindi("");
    }
  };

  // const handleOptionChange = (e) => {
  //   setpaN_Form60(e.target.value);
  //   setPanNo("");
  //   setSelectedDate("");
  //   //console.log(paN_Form60);
  // };

  const handleOptionChange = (e) => {
    const value = e.target.value;
    setpaN_Form60(value);
    setPanNo("");

    if (value === "form60") {
      setForm60Date(null); // start fresh
    } else {
      setForm60Date(null); // clear previous form60 DOB
    }
  };

  const filteredIdTypeData =
    appointmentType === "V" || isOTPVerified
      ? idTypeData.filter(
          (option) => option.iD_CODE === "00" || option.iD_CODE === "04"
        ) // Only ADHAAR
      : idTypeData;

  const regexPatterns = {
    "01": /^[A-Z]{3}[0-9]{7}$/, // VOTER ID: Example: ABC1234567
    "02": /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, // PAN CARD: Example: ABCDE1234F
    "03": /^[A-Z]{2}[0-9]{13}$/, // DL: Example: DL0123456789123
    "04": /^[0-9]{12}$/, // ADHAAR: Example: 123456789012
  };

  const handleIDNoChange = (e) => {
    const value = e.target.value.toUpperCase();
    const pattern = regexPatterns[identificationType];
    if (pattern && !pattern.test(value)) {
      setError("Invalid ID No. for " + idName);
    } else {
      setError("");
    }
    setIDNo(value);
  };

  // const handleRadioChange = (event) => {
  //   const value = event.target.value;
  //   setIsPartySignUpModify(false);
  //   setConfirmed(value); // Update confirmed state
  //   dispatch(clearAadhaarDetails());
  // };

  const handleRadioChange = (event) => {
    const value = event.target.value;
    setIsPartySignUpModify(false);
    setConfirmed(value);
    dispatch(clearAadhaarDetails());

    if (value === "yes") {
      dispatch(setConfirmedYes());
    } else {
      dispatch(setConfirmedNo());
    }
  };

  useEffect(() => {
    if (confirmed === "no" && !PartySignUpDetails) {
      dispatch(setConfirmedNo());
      dispatch(resetPartySignUpDetails());
      setIsSignUpModalOpen(true); // Open the sign-up modal when confirmed is "no"
      setIsMobileModalOpen(false);
    } else if (confirmed === "yes" && isMobileVerified === false) {
      dispatch(setConfirmedYes());
      dispatch(resetPartySignUpDetails());
      setIsMobileModalOpen(true);
      setIsSignUpModalOpen(false); // Open the mobile verification modal if mobile is not verified
    } else if (
      confirmed === "yes" &&
      isMobileVerified === true &&
      datatableEntries.length > 0
    ) {
      dispatch(resetPartySignUpDetails());
      setIsMobileModalOpen(false);
    } else {
      setIsMobileModalOpen(false);
    }
  }, [confirmed, isMobileVerified]);

  // trial for refresh before save button and show yes or no radio buttons starts

  useEffect(() => {
    const storedEntries = sessionStorage.getItem("datatableEntries");

    if (storedEntries) {
      const parsedEntries = JSON.parse(storedEntries);

      // Check if a specific entry is present
      const isEntryPresent = parsedEntries.some(
        (entry) => entry.mobile_No === Mobile
      );

      if (isEntryPresent) {
        setDatatableEntries(parsedEntries);
      } else {
        resetFormAndShowConfirmation();
      }
    } else {
      resetFormAndShowConfirmation();
    }
  }, []);

  const resetFormAndShowConfirmation = () => {
    dispatch(setisMobileVerified(false));
    dispatch(clearAadhaarDetails());
    dispatch(resetPartySignUpDetails());

    setConfirmed(null); // Show confirmation message
  };

  // trial for refresh before save button and show yes or no radio buttons ends

  return (
    <>
      {/* {confirmed === null && !(isMobileVerified || aadhaarDetails) && ( */}
      {/* {!isEditMode &&
        (confirmed === null ||
          confirmedSlice === null ||
          datatableEntries.length === 0) &&
        (isMobileVerified === false || !PartySignUpDetails) && ( */}
      {!isEditMode && confirmed === null && !PartySignUpDetails && (
        <div className="flex justify-center items-center py-10 gap-16 3xl:gap-28">
          <div className="confirmation-message bg-[#E8EFF2] p-6 rounded-md shadow-md text-center w-96 3xl:w-1/3 3xl:h-36">
            <p className="text-md font-semibold mt-4">
              Is User Already Registered With UK PDE???
            </p>
            <div className="flex justify-center mt-6 gap-4">
              <label className="flex items-center">
                <input
                  type="radio"
                  name="confirmation"
                  value="yes"
                  className="mr-2"
                  onChange={handleRadioChange}
                />
                Yes
              </label>
              <label className="flex items-center">
                <input
                  type="radio"
                  name="confirmation"
                  value="no"
                  className="mr-2"
                  onChange={handleRadioChange}
                />
                No
              </label>
            </div>
          </div>
          <div className="ml-10">
            <img
              src={partydetailsimg}
              alt="Illustration"
              className="h-64 3xl:h-80"
            />
          </div>
        </div>
      )}

      {isSignUpModalOpen && confirmed !== null && (
        <PartySignUpModal
          isOpen={isSignUpModalOpen}
          onClose={() => {
            setIsSignUpModalOpen(false);
            setReEkyc(false);
          }}
          isPartySignUpModify={isPartySignUpModify}
          reEkyc={reEkyc}
          setIsPartySignUpModify={setIsPartySignUpModify}
        />
      )}

      {/* Render MobileModal when the modal state is true */}
      {isMobileModalOpen && (
        <MobileModal
          isOpen={isMobileModalOpen}
          onClose={() => setIsMobileModalOpen(false)}
          appointmentType={appointmentType}
          activeTab={"firstParty"}
          // onSuccess={({ regRadio, Reg_Code }) => {
          //   console.log("Received from modal:");
          //   console.log("Selected Option:", regRadio);
          //   console.log("Selected Code:", Reg_Code);
          //   setRegistration_For(regRadio);
          //   setReg_code(Reg_Code);
          // }}
        />
      )}
      {isPhotoVisible && Photo ? (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center backdrop-blur-md"
          onClick={() => setIsPhotoVisible(false)}
        >
          <div className="w-48 h-48 rounded-full overflow-hidden border-4 border-white shadow-lg bg-white">
            <img
              src={`data:image/jpeg;base64,${Photo}`}
              // src={
              //   PartySignUpDetails[0]?.Photo
              //     ? `data:image/jpeg;base64,${PartySignUpDetails[0]?.Photo}`
              //     : "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
              // }
              alt="User Photo"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      ) : (
        <>
          {((confirmed === "yes" &&
            isMobileVerified &&
            (appointmentType === "P" ||
              (appointmentType === "V" && adhaarEkyc === "Y") ||
              appointmentType === "L")) ||
            (confirmedSlice === null && PartySignUpDetails) ||
            (confirmed === "no" && PartySignUpDetails) ||
            isEditMode) && (
            <form onSubmit={handleSave}>
              <div className="grid gap-4 m-8 sm:grid-cols-12 grid-cols-2 items-center">
                <label className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1">
                  ID Type:
                </label>
                <div className="block w-full relative sm:col-span-3 grid-cols-1">
                  <select
                    name="identificationType"
                    value={identificationType}
                    disabled
                    // onChange={(e) => setIdentificationType(e.target.value)}
                    onChange={(e) => {
                      const selectedOption = filteredIdTypeData.find(
                        (option) => option.iD_CODE === e.target.value
                      );
                      setIdentificationType(e.target.value);
                      setidName(selectedOption.id); // Set name to the selected option's id
                      setError(""); // Clear any previous errors when ID type changes
                      setIDNo("");
                      resetFields();
                    }}
                    required
                    className="block w-full pl-2 pr-8 py-1.5 border-none bg-gray-100 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  >
                    {/* <option value="">Select</option> */}
                    {filteredIdTypeData.map((option) => (
                      <option key={option.iD_CODE} value={option.iD_CODE}>
                        {option.id}
                      </option>
                    ))}
                  </select>
                  <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                </div>

                <label className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1">
                  ID No.:
                </label>
                <div className="block w-full relative sm:col-span-3 grid-cols-1">
                  <input
                    type="IDNo"
                    id="IDNo"
                    name="IDNo"
                    value={IDNo}
                    disabled
                    onChange={handleIDNoChange}
                    className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm uppercase"
                    required
                  />
                  <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />

                  {error && (
                    <p className="text-red-500 text-xs mt-2 absolute">
                      {error}
                    </p>
                  )}
                </div>
                {identificationType === "04" && (
                  <div className="block w-full relative sm:col-span-3 grid-cols-1">
                    <span
                      onClick={handelReEkyc}
                      className="text-black font-semibold"
                    >
                      Re-Ekyc?
                    </span>
                  </div>
                )}
              </div>

              <div className="grid gap-4 m-8 sm:grid-cols-12 grid-cols-2 items-center">
                <label className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1">
                  Name:
                </label>
                <div className="block w-full relative sm:col-span-3 grid-cols-1">
                  <input
                    type="Name"
                    id="Name"
                    name="Name"
                    value={Name}
                    onChange={handleNameChange}
                    className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                    required
                    disabled={identificationType === "04"}
                  />
                  <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                </div>

                <label className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1">
                  नाम:
                </label>
                <div className="block w-full relative sm:col-span-3 grid-cols-1">
                  <input
                    type="HindiName"
                    id="HindiName"
                    name="HindiName"
                    value={HindiName}
                    // onChange={(e) => setHindiName(e.target.value)}
                    // onChange={(e) => {
                    //   const filtered = e.target.value.replace(
                    //     /[^\u0900-\u097F\s]/g,
                    //     ""
                    //   );
                    //   setHindiName(filtered);
                    // }}
                    onChange={(e) => {
                      const raw = e.target.value;
                      const filtered = raw
                        .replace(/[^\u0900-\u097F\s]/g, "")
                        .trimStart();
                      setHindiName(filtered.replace(/\s+/g, " ").trim());
                    }}
                    className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                    required
                    // disabled={identificationType === "04" && aadhaarDetails}
                  />
                  <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                </div>

                <label className="block w-full relative text-sm font-semibold sm:col-span-1">
                  Relation:
                </label>
                <div className="block w-full relative sm:col-span-3">
                  <select
                    name="Relation"
                    value={relation}
                    onChange={(e) => setRelation(e.target.value)}
                    required
                    disabled={identificationType === "04"}
                    className="block w-full pl-2 pr-8 py-1.5 border-none bg-gray-100 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  >
                    {relationData.map((option) => (
                      <option
                        key={option.relatioN_CODE}
                        value={option.relatioN_CODE}
                      >
                        {option.relation}
                      </option>
                    ))}
                  </select>
                  <hr className="absolute left-0  bottom-0 w-full h-0.5 border-none bg-gray-500" />
                </div>
              </div>
              <div className="grid gap-4 m-8 sm:grid-cols-12 grid-cols-2 items-center">
                <label className="block w-full relative text-sm font-semibold sm:col-span-1">
                  Relative Name:
                </label>
                <div className="block w-full relative sm:col-span-3">
                  <input
                    type="text"
                    id="Relative"
                    name="Relative"
                    value={Relative}
                    onChange={handleRelativeChange}
                    disabled={identificationType === "04"}
                    className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                    required
                  />
                  <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                </div>

                <label className="block w-full relative text-sm font-semibold sm:col-span-1">
                  रिश्तेदार:
                </label>
                <div className="block w-full relative sm:col-span-3">
                  <input
                    type="text"
                    id="RelativeHindi"
                    name="RelativeHindi"
                    value={RelativeHindi}
                    onChange={(e) => {
                      const filtered = e.target.value.replace(
                        /[^\u0900-\u097F\s]/g,
                        ""
                      );
                      setRelativeHindi(filtered);
                    }}
                    className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                    required
                  />
                  <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                </div>
                <label className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1">
                  Gender:
                </label>
                <div className="block w-full relative sm:col-span-3 grid-cols-1">
                  <select
                    name="Gender"
                    value={Gender}
                    onChange={handleGenderChange}
                    disabled={identificationType === "04"}
                    required
                    className="block w-full pl-2 pr-8 py-1.5 border-none bg-gray-100 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  >
                    {Array.isArray(genderData) &&
                      genderData.map((option) => (
                        <option
                          key={option.gendeR_CODE}
                          value={option.gendeR_CODE}
                        >
                          {option.gender}
                        </option>
                      ))}
                  </select>
                  <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                </div>
              </div>
              <div className="grid gap-4 m-8 sm:grid-cols-12 grid-cols-2 items-center">
                <label className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1">
                  Occupation:
                </label>
                <div className="block w-full relative sm:col-span-3 grid-cols-1">
                  <select
                    name="Occupation"
                    value={Occupation}
                    // onChange={(e) => setOccupation(e.target.value)}
                    onChange={(e) => {
                      const selectedOption = occupationData.find(
                        (option) => option.occupatioN_CODE === e.target.value
                      );
                      setOccupation(e.target.value);
                      setoccupationName(selectedOption.occupation); // Set name to the selected option's id
                    }}
                    required
                    className="block w-full pl-2 pr-8 py-1.5 border-none bg-gray-100 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  >
                    {/* <option value="">Mode Of Payment</option> */}
                    {/* <option value="" disabled>
                      Select occupation
                    </option> */}
                    {occupationData.map((option) => (
                      <option
                        key={option.occupatioN_CODE}
                        value={option.occupatioN_CODE}
                      >
                        {option.occupation}
                      </option>
                    ))}
                  </select>
                  <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                </div>

                <label className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1">
                  Mobile No:
                </label>
                <div className="block w-full relative sm:col-span-3 grid-cols-1">
                  <input
                    type="text"
                    id="Mobile"
                    name="Mobile"
                    value={Mobile}
                    maxLength={10}
                    // onChange={(e) => setMobile(e.target.value)}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only digits and limit to 10 characters
                      if (/^\d*$/.test(value) && value.length <= 10) {
                        setMobile(value);
                      }
                    }}
                    className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                    required
                  />
                  <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                </div>
                <label className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1">
                  <input
                    type="radio"
                    name="formType"
                    value="form60"
                    checked={
                      isModifying
                        ? paN_Form60 === "form60"
                        : paN_Form60 === "form60"
                    }
                    onChange={handleOptionChange}
                  />
                  <span className="ml-1">Form 60</span>
                </label>
                <label className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1">
                  <input
                    type="radio"
                    name="formType"
                    value="PAN"
                    checked={
                      isModifying ? paN_Form60 === "PAN" : paN_Form60 === "PAN"
                    }
                    onChange={handleOptionChange}
                  />
                  <span className="ml-1">PAN no</span>
                </label>
                {/* {paN_Form60 === "form60" && (
                  <div className="block w-full relative sm:col-span-2 grid-cols-1">
                    <input
                      type="date"
                      name="selectedDate"
                      value={
                        selectedDate
                          ? selectedDate.toISOString().split("T")[0]
                          : ""
                      }
                      onChange={(e) =>
                        setSelectedDate(new Date(e.target.value))
                      }
                      className="block w-full pl-2 pr-8 py-1.5 border-none bg-gray-100 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    />
                    <hr className="absolute left-0 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                  </div>
                )} */}
                {paN_Form60 === "form60" && (
                  <div className="block w-full relative sm:col-span-2 grid-cols-1">
                    <input
                      type="date"
                      name="form60Date"
                      value={
                        form60Date ? form60Date.toISOString().split("T")[0] : ""
                      }
                      onChange={(e) => setForm60Date(new Date(e.target.value))}
                      className="block w-full pl-2 pr-8 py-1.5 border-none bg-gray-100 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    />
                    <hr className="absolute left-0 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                  </div>
                )}

                {paN_Form60 === "PAN" && (
                  <div className="block w-full relative sm:col-span-2 grid-cols-1">
                    {/* Render your PAN specific input or modify as needed */}
                    <input
                      type="text"
                      name="paN_no"
                      placeholder="Enter PAN number"
                      value={paN_no}
                      maxLength={10}
                      // onChange={(e) => setPanNo(e.target.value)}
                      onChange={(e) => {
                        const value = e.target.value.toUpperCase(); // Convert input to uppercase
                        // Allow partial inputs, but set value only if it matches the complete PAN format
                        if (/^[A-Z0-9]*$/.test(value)) {
                          setPanNo(value);
                        }
                      }}
                      className="block w-full pl-2 pr-8 py-1.5 border-none bg-gray-100 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    />
                    <hr className="absolute left-0 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                  </div>
                )}
              </div>
              <div className="grid gap-4 m-8 sm:grid-cols-12 grid-cols-2 items-center">
                <label className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1">
                  Email:
                </label>
                <div className="block w-full relative sm:col-span-3 grid-cols-1">
                  <input
                    type="Email"
                    id="Email"
                    Email="Email"
                    value={Email}
                    placeholder="abc@example.com"
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only digits and limit to 10 characters
                      if (/^[a-zA-Z0-9]+@(?:[a-zA-Z0-9]+\.)+[A-Za-z]+$/) {
                        setEmail(value);
                      }
                    }}
                    className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                    required
                    // disabled={identificationType === "04"}
                  />
                  <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                </div>

                <span
                  onClick={() => setIsPhotoVisible(true)}
                  className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1 text-blue-300"
                >
                  View Photo
                </span>
                <div className="block w-full relative sm:col-span-3 grid-cols-1"></div>

                <label className="block w-full relative text-sm font-semibold sm:col-span-1"></label>
                <div className="block w-full relative sm:col-span-3"></div>
              </div>

              <div className="grid gap-2 m-8 sm:grid-cols-11 items-center">
                <label className="block w-full relative text-sm font-semibold sm:col-span-1">
                  Address:
                </label>

                {[
                  { id: "HouseNo", value: HouseNo, setValue: setHouseNo },
                  { id: "Locality", value: Locality, setValue: setLocality },
                  { id: "Area", value: Area, setValue: setArea },
                ].map(({ id, value, setValue }) => (
                  <div key={id} className="block w-full relative sm:col-span-3">
                    <label
                      htmlFor={id}
                      className="absolute left-4 -top-2.5 text-gray-400 text-sm font-serif px-1"
                    >
                      {id}
                    </label>
                    <input
                      type="text"
                      id={id}
                      name={id}
                      value={value}
                      onChange={(e) => setValue(e.target.value)}
                      disabled={identificationType === "04"}
                      className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                      required
                    />
                    <hr className="absolute left-0 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                  </div>
                ))}
              </div>

              <div className="grid gap-2 m-8 sm:grid-cols-11 items-center">
                <label className="block w-full relative text-sm font-semibold sm:col-span-1"></label>

                {[
                  {
                    id: "State",
                    value: State,
                    onChange: handleStateChange,
                    options: stateOptions,
                  },
                  {
                    id: "District",
                    value: district,
                    onChange: handleDistrictChange,
                    options: districtOptions,
                  },
                ].map(({ id, value, onChange, options }) => (
                  <div key={id} className="block w-full relative sm:col-span-3">
                    <label
                      htmlFor={id}
                      className="absolute left-4 -top-2.5 text-gray-400 text-sm font-serif px-1"
                    >
                      {id}
                    </label>
                    <select
                      id={id}
                      className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                      value={value}
                      onChange={onChange}
                      required
                    >
                      <option value="">{id}</option>
                      {options.map((option) => (
                        <option
                          key={option[`${id.toLowerCase()}ID`]}
                          value={option[`${id.toLowerCase()}ID`]}
                        >
                          {option[`${id.toLowerCase()}Name`]}
                        </option>
                      ))}
                    </select>
                    <hr className="absolute left-0 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                  </div>
                ))}

                <div className="block w-full relative sm:col-span-3">
                  <label
                    htmlFor="Pincode"
                    className="absolute left-4 -top-2.5 text-gray-400 text-sm font-serif px-1"
                  >
                    Pincode
                  </label>
                  <input
                    type="tel"
                    id="Pincode"
                    name="Pincode"
                    placeholder="Pincode"
                    value={Pincode}
                    maxLength={6}
                    minLength={6}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d{0,6}$/.test(value)) {
                        setPincode(value);
                      }
                    }}
                    disabled={identificationType === "04"}
                    className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                    required
                  />
                  <hr className="absolute left-0 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                </div>
              </div>

              {appointmentType === "L" && (
                <div className="grid gap-4 m-8 sm:grid-cols-12 items-center">
                  <label className="block text-sm font-semibold sm:col-span-1">
                    Registration For:
                  </label>
                  <div className="sm:col-span-11 flex gap-6">
                    {["Self", "Minor", "POA"].map((label) => (
                      <label
                        key={label}
                        className="flex items-center gap-2 text-sm"
                      >
                        <input
                          type="radio"
                          name="regRadio"
                          value={label}
                          checked={Registration_For === label}
                          onChange={(e) => {
                            const selected = e.target.value;

                            // ✅ Clear POA-related fields on any change
                            setPOADate("");
                            setOffice("");
                            setDocumentNo("");
                            setPOAYear("");

                            // ✅ Then set selected value and Reg_Code
                            setRegistration_For(selected);

                            if (selected === "Self") {
                              setReg_Code("01");
                            } else if (selected === "Minor") {
                              setReg_Code("02");
                            } else if (selected === "POA") {
                              setReg_Code("03");
                            }
                          }}
                        />
                        {label}
                      </label>
                    ))}
                  </div>
                </div>
              )}

              {appointmentType === "L" && Registration_For === "POA" && (
                <div className="grid gap-2 m-8 sm:grid-cols-10 items-center">
                  <label className="block w-full relative text-sm font-semibold sm:col-span-1">
                    POA Details:
                  </label>

                  {[
                    { id: "POADate", value: POADate, setValue: setPOADate },
                    { id: "Office", value: Office, setValue: setOffice },
                    {
                      id: "DocumentNo",
                      value: DocumentNo,
                      setValue: setDocumentNo,
                    },
                    { id: "POAYear", value: POAYear, setValue: setPOAYear },
                  ].map(({ id, value, setValue }) => (
                    <div
                      key={id}
                      className="block w-full relative sm:col-span-2"
                    >
                      <label
                        htmlFor={id}
                        className="absolute left-4 -top-2.5 text-gray-400 text-sm font-serif px-1"
                      >
                        {id}
                      </label>
                      <input
                        type={id === "POADate" ? "date" : "text"}
                        id={id}
                        name={id}
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                        className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                        required
                      />
                      <hr className="absolute left-0 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                    </div>
                  ))}
                </div>
              )}

              <div className="flex justify-center mt-5 gap-4">
                <button
                  className="px-6 py-1.5 m-2 bg-blue-500 text-white rounded-full text-md"
                  // onClick={handleSave}
                  type="submit"
                >
                  Add
                </button>

                <button
                  className="px-6 py-1.5 m-2 bg-blue-500 text-white rounded-full text-md"
                  onClick={onNext}
                >
                  Next
                </button>
              </div>
            </form>
          )}
        </>
      )}

      <div className="flex justify-center m-3 gap-4">
        <Datatable
          entries={datatableEntries}
          onDelete={handleDelete}
          onEdit={handleEdit}
          appointmentType={appointmentType}
          activeTab={"firstParty"}
        />
      </div>
      <AadhaarOTPModal
        isOpen={showOtpForm}
        onClose={() => setShowOtpForm(false)}
      />
    </>
  );
};

const SecondPartyForm = ({ onNext }) => {
  const { relationData, occupationData, idTypeData, genderData } = useSelector(
    (state) => state.PartyDetail
  );
  const appointmentType = useSelector(
    (state) => state.Procedure.appointmentType
  );
  const adhaarEkyc = useSelector(selectAdhaarEkyc);

  const pde = useSelector(selectPdEId);
  const pdeInfo = useSelector(selectPDEInfo);
  const pdeData = pdeInfo?.pdeData[0];
  const partyDetails = pdeInfo?.partyDetails[0];

  const translatedText = useSelector(selectTranslatedText);

  const idProofOptions = useSelector(selectIdProofOptions);
  const aadhaarDetails = useSelector(selectAadhaarDetails);
  const [identificationType, setIdentificationType] = useState("");
  const [IDNo, setIDNo] = useState("");
  const [idName, setidName] = useState("");
  const dispatch = useDispatch();
  const [showOtpForm, setShowOtpForm] = useState(false);

  const [Name, setName] = useState("");
  const [HindiName, setHindiName] = useState("");
  const [relation, setRelation] = useState("");
  const [Relative, setRelative] = useState("");
  const [RelativeHindi, setRelativeHindi] = useState("");
  const [Gender, setGender] = useState("");
  const [GenderName, setGenderName] = useState("");
  const [Occupation, setOccupation] = useState("");
  const [occupationName, setoccupationName] = useState("");
  const [Mobile, setMobile] = useState("");
  const [Email, setEmail] = useState("");
  const [Photo, setPhoto] = useState("");
  const [isPhotoVisible, setIsPhotoVisible] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [form60Date, setForm60Date] = useState(null); // For First & Second Party only

  const [HouseNo, setHouseNo] = useState("");
  const [Locality, setLocality] = useState("");
  const [Area, setArea] = useState("");
  const [State, setState] = useState("");
  const [district, setDistrict] = useState("");
  const [stateName, setStateName] = useState("");
  const [districtName, setDistrictName] = useState("");
  const [Pincode, setPincode] = useState("");
  const [datatableEntries2, setDatatableEntries2] = useState([]);
  const [paN_Form60, setpaN_Form60] = useState("PAN");
  const [paN_no, setPanNo] = useState("");
  const [POADate, setPOADate] = useState("");
  const [POAYear, setPOAYear] = useState("");
  const [Office, setOffice] = useState("");
  const [DocumentNo, setDocumentNo] = useState("");
  const [Registration_For, setRegistration_For] = useState("");
  const [Reg_Code, setReg_Code] = useState("");
  const stateOptions = useSelector(selectStateOptions);
  const districtOptions = useSelector(selectDistrictOptions);
  const [isEditing, setIsEditing] = useState(false);
  const [editId, setEditId] = useState(null);
  const isModifying = useSelector(selectIsModifying);
  const [error, setError] = useState("");
  const [confirmed, setConfirmed] = useState(null);
  const [isSignUpModalOpen, setIsSignUpModalOpen] = useState(false);
  const [isMobileModalOpen, setIsMobileModalOpen] = useState(false);
  const PartySignUpDetails = useSelector(selectPartySignUpDetails);
  const [isEditMode, setIsEditMode] = useState(false);
  const isOTPVerified = useSelector(selectIsOTPVerified);
  const isMobileVerified = useSelector(selectisMobileVerified);
  const confirmedSlice = useSelector(selectConfirmed);
  const [isPartySignUpModify, setIsPartySignUpModify] = useState(false);
  const [reEkyc, setReEkyc] = useState(false);

  useEffect(() => {
    if (confirmedSlice === null) {
      setConfirmed(confirmedSlice);
    }
  }, [confirmedSlice]);

  useEffect(() => {
    if (
      PartySignUpDetails &&
      adhaarEkyc === "N" &&
      PartySignUpDetails[0]?.identificationType !== "04" &&
      (appointmentType === "V" || appointmentType === "VI") &&
      confirmed !== null &&
      isOTPVerified === false
    ) {
      setIsMobileModalOpen(false);
      setIsPartySignUpModify(true);
      setIsSignUpModalOpen(true);
      dispatch(clearAadhaarDetails());
      setisMobileVerified(false);
    }
  }, [PartySignUpDetails, appointmentType, confirmed, isOTPVerified]);
  useEffect(() => {
    if (
      PartySignUpDetails &&
      adhaarEkyc === "N" &&
      (appointmentType === "V" || appointmentType === "VI")
    ) {
      setIsMobileModalOpen(false);
      setIsPartySignUpModify(true);
      setIsSignUpModalOpen(true);
      // dispatch(resetPartySignUpDetails());
      // dispatch(setConfirmedNo());
      dispatch(clearAadhaarDetails());
      // dispatch(resetConfirmed());
      setisMobileVerified(false);
    }
  }, [PartySignUpDetails, appointmentType, confirmed, isMobileVerified]);

  useEffect(() => {
    dispatch(fetchStateDataAsync());
    dispatch(fetchGender());
    dispatch(fetchIDTypeData());
    dispatch(fetchOccupationData());
    // if (State) {
    //   dispatch(fetchDistrictData(State));
    // }
  }, [dispatch]);

  const handleStateChange = (e) => {
    //;
    const stateId = e.target.value; // This is a string from the select input
    setState(stateId); // Set the state ID

    // Ensure that stateOptions is an array before proceeding
    if (Array.isArray(stateOptions)) {
      const selectedState = stateOptions.find(
        (option) => option.stateID.toString() === stateId // Convert stateID to string for comparison
      );

      //console.log("State ID from select:", stateId);
      //console.log("Selected State:", selectedState);

      setStateName(selectedState ? selectedState.stateName : ""); // Set the state name

      if (selectedState) {
        dispatch(fetchDistrictDataAsync(stateId)); // Fetch district data if a state is selected
      }
    } else {
      console.error("stateOptions is not an array or is undefined");
    }
  };

  const handleDistrictChange = (e) => {
    const districtID = e.target.value; // This is a string from the select input
    setDistrict(districtID); // Set the state ID

    // Ensure that stateOptions is an array before proceeding
    if (Array.isArray(districtOptions)) {
      const selectedDistrict = districtOptions.find(
        (option) => option.districtID.toString() === districtID
      );
      setDistrictName(selectedDistrict ? selectedDistrict.districtName : "");
    } else {
      console.error("stateOptions is not an array or is undefined");
    }
  };

  useEffect(() => {
    const storedEntries = sessionStorage.getItem("datatableEntries2");
    if (storedEntries) {
      setDatatableEntries2(JSON.parse(storedEntries));
    }
  }, []);

  useEffect(() => {
    if (pde || PartySignUpDetails) {
      dispatch(fetchPDEInfoAsync(pde));
      dispatch(fetchRelationData());
      dispatch(fetchOccupationData());
      dispatch(fetchIDTypeData());
    }
  }, [dispatch, pde, PartySignUpDetails]);

  useEffect(() => {
    if (
      PartySignUpDetails?.length &&
      ((appointmentType === "V" && adhaarEkyc === "Y") ||
        appointmentType === "P" ||
        appointmentType === "L")
    ) {
      const firstDetail = PartySignUpDetails[0];
      setIdentificationType(firstDetail.identificationType || "");
      setIDNo(firstDetail.identificationNumber || "");
      setName(firstDetail.name || "");
      setRelation(firstDetail.relationShip);
      setRelative(firstDetail.father_Mother_guardian_Name || "");
      setGender(firstDetail.addGender || "");
      setMobile(firstDetail.mobileNo || "");
      setHouseNo(firstDetail.addHousenoFlat || "");
      setLocality(firstDetail.addBuilding_Landmark || "");
      setArea(firstDetail.addAreaLocality || "");
      setState(firstDetail.addState || "");
      setDistrict(firstDetail.addDistrict || "");
      setPincode(firstDetail.addPinCode || "");
      setEmail(firstDetail.email || "");
      setPhoto(firstDetail.photo || "");
      if (appointmentType === "L") {
        setPOADate(firstDetail.poaDate || "");
        setPOAYear(firstDetail.poaYear || "");
        setOffice(firstDetail.office || "");
        setDocumentNo(firstDetail.documentNo || "");
        setRegistration_For(firstDetail.registration_For || "");
        setReg_Code(firstDetail.reg_Code || "");
      }

      // Fetch state details
      const selectedState = stateOptions.find(
        (option) =>
          option.stateID.toString() === firstDetail.addState.toString()
      );

      setStateName(selectedState ? selectedState.stateName : "");
      if (selectedState) {
        dispatch(fetchDistrictDataAsync(selectedState.stateID));
        const genderMap = {
          "01": "Male",
          "02": "Female",
          "03": "Transgender",
        };

        const genderName = genderMap[firstDetail.addGender] || "";
        setGender(firstDetail.addGender || "");
        setGenderName(genderName);

        // Translate name and relative name
        if (firstDetail.name) {
          dispatch(
            translateTextAsync({
              text: firstDetail.name,
              source: "en",
              target: "hi",
              field: "Name",
            })
          );
        }
        if (firstDetail.father_Mother_guardian_Name) {
          dispatch(
            translateTextAsync({
              text: firstDetail.father_Mother_guardian_Name,
              source: "en",
              target: "hi",
              field: "Relative",
            })
          );
        }
      }
    }
  }, [PartySignUpDetails, stateOptions, dispatch]);

  useEffect(() => {
    if (districtOptions.length > 0 && PartySignUpDetails?.length) {
      const selectedDistrict = districtOptions.find(
        (option) =>
          option.districtID.toString() ===
          PartySignUpDetails[0].addDistrict.toString()
      );

      // console.log(
      //   "District ID from select:",
      //   PartySignUpDetails[0].addDistrict
      // );
      // console.log("Selected District:", selectedDistrict);

      setDistrictName(selectedDistrict ? selectedDistrict.districtName : "");
    }
  }, [districtOptions, PartySignUpDetails]);

  useEffect(() => {
    if (translatedText) {
      setHindiName(translatedText.Name || "");
      setRelativeHindi(translatedText.Relative || "");
    }
  }, [translatedText]);

  const validateInputs = () => {
    // const idNoRegex = /^[0-9]{12}$/; // Example regex for a 12-digit ID number
    const mobileRegex = /^[0-9]{10}$/; // Regex for a 10-digit mobile number
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/; // Regex for PAN number format
    // const emailRegex = /^[a-zA-Z0-9]+@(?:[a-zA-Z0-9]+\.)+[A-Za-z]+$/;
    const emailRegex =
      /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    if (appointmentType === "L" && !Registration_For) {
      toast.error("Please select a 'Registration For' option.");
      return false;
    }

    if (appointmentType === "L" && Registration_For === "POA") {
      if (!POADate || !Office || !DocumentNo || !POAYear) {
        toast.error("Please fill all POA details.");
        return false;
      }
    }

    if (!mobileRegex.test(Mobile)) {
      toast.error("Please enter a valid mobile number (10 digits).");
      return false;
    }

    if (!emailRegex.test(Email)) {
      toast.error("Please enter a valid Email");
      return false;
    }

    if (paN_Form60 === "PAN" && !panRegex.test(paN_no)) {
      toast.error("Please enter a valid PAN number.");
      return false;
    }

    if (!Occupation) {
      toast.error("Please select an occupation.");
      return false;
    }

    return true;
  };

  const handleGenderChange = (e) => {
    const selectedGenderCode = e.target.value;
    setGender(selectedGenderCode); // Set the gender code
    const selectedGender = genderData.find(
      (option) => option.gendeR_CODE === selectedGenderCode
    );
    setGenderName(selectedGender ? selectedGender.gender : ""); // Set the gender name
  };

  const resetFields = () => {
    setName("");
    setHindiName("");
    setRelation("");
    setRelative("");
    setRelativeHindi("");
    setGender("");
    setGenderName("");
    setOccupation("");
    setoccupationName("");
    setMobile("");
    setSelectedDate("");
    setHouseNo("");
    setLocality("");
    setArea("");
    setState("");
    setStateName("");
    setDistrict("");
    setDistrictName("");
    setPincode("");
    setPanNo("");
    setEmail("");
    setPOADate("");
    setPOAYear("");
    setOffice("");
    setDocumentNo("");
    setRegistration_For("");
    setReg_Code("");
  };

  const handelReEkyc = () => {
    setReEkyc(true);
    setIsPartySignUpModify(true);
    setIsSignUpModalOpen(true);
  };

  const handleSave = (e) => {
    const pattern = regexPatterns[identificationType];
    e.preventDefault(); // Prevent default form submission
    if (!validateInputs()) {
      return;
    }
    if (pattern && !pattern.test(IDNo)) {
      setError("Invalid ID No. for " + idName);
      return;
    }

    const newData = {
      id: isEditing ? editId : uuidv4(),
      id_No: IDNo,
      idName: PartySignUpDetails
        ? filteredIdTypeData.find(
            (option) => option.iD_CODE === identificationType
          )?.id || ""
        : idName,
      id_Type_Code: identificationType,
      name_Eng: Name,
      name_Hin: HindiName,
      relation: relation,
      father_Name_Eng: Relative,
      father_Name_Hin: RelativeHindi,
      gender: GenderName,
      gendeR_CODE: Gender,
      vtc: "",
      paN_Form60: paN_Form60,
      paN_no: paN_no,
      form60: form60Date ? form60Date.toISOString().split("T")[0] : null,
      occu_Code: Occupation,
      occupation: occupationName,
      mobile_No: Mobile,
      email: Email,
      dob: null,
      country: "India",
      house_no: HouseNo,
      landmark: Locality,
      street: Area,
      state: State,
      stateName: stateName,
      district: district,
      districtName: districtName,
      pincode: Pincode,
      photo: Photo || null,
      ...(appointmentType === "L" && {
        POADate: POADate,
        Office: Office,
        DocumentNo: DocumentNo,
        POAYear: POAYear,
        Reg_Code: Reg_Code,
        Registration_For: Registration_For,
      }),
    };

    // Add newData to datatableEntries

    const updatedEntries = isEditing
      ? datatableEntries2.map((entry) =>
          entry.id === editId ? newData : entry
        )
      : [...datatableEntries2, newData];

    //console.log("After update:");
    //console.log("updatedEntries:", updatedEntries);
    setDatatableEntries2(updatedEntries);

    // Store updatedEntries in localStorage
    sessionStorage.setItem("datatableEntries2", JSON.stringify(updatedEntries));
    dispatch(setSecondPartyDetails(updatedEntries));

    // Clear form fields after saving
    setIDNo("");
    setIdentificationType("");
    setidName("");
    setEditId(null);
    setIsEditing(false);
    dispatch(clearAadhaarDetails());
    dispatch(resetPartySignUpDetails());
    //console.log(PartySignUpDetails);
    dispatch(setisMobileVerified(false));
    setConfirmed(null);
    dispatch(clearTranslation());
    dispatch(resetConfirmed());
    resetFields();
    setIsEditMode(false);
    setIsPartySignUpModify(false);
  };
  const handleDelete = (id) => {
    //console.log("Deleting item with ID:", id);

    // Ensure `id` is a string or match the format of `datatableEntries` ids
    const idToDelete = id.id || id; // Use `id.id` if `id` is an object

    // Filter out the entry with the matching `id`
    const updatedEntries = datatableEntries2.filter(
      (entry) => entry.id !== idToDelete
    );

    //console.log("Updated Entries after delete:", updatedEntries);

    setDatatableEntries2(updatedEntries);
    dispatch(setSecondPartyDetails(updatedEntries));
    // localStorage.setItem("datatableEntries2", JSON.stringify(updatedEntries));
    sessionStorage.setItem("datatableEntries2", JSON.stringify(updatedEntries));
    dispatch(clearTranslation());
  };

  const handleEdit = (id) => {
    setIsEditMode(true);
    // Find the entry to edit based on the ID provided
    const entryToEdit = datatableEntries2.find((entry) => entry.id === id);

    //console.log("Editing entry with ID:", id);
    //console.log("Current DataTable Entries:", datatableEntries2);

    // Log details of each entry for debugging
    datatableEntries2.forEach((entry) => {
      //console.log("Entry keys:", Object.keys(entry)); // Log the keys of the entry
      //console.log("Entry values:", entry); // Log the entire entry object
    });

    // Check if the entry was found
    //console.log("Entry to edit:", entryToEdit);
    if (entryToEdit) {
      // Populate form fields with the entry data
      setIDNo(entryToEdit.id_No);
      setidName(entryToEdit.idName);
      setIdentificationType(entryToEdit.id_Type_Code);
      setName(entryToEdit.name_Eng);
      setHindiName(entryToEdit.name_Hin);
      setRelation(entryToEdit.relation);
      setRelative(entryToEdit.father_Name_Eng);
      setRelativeHindi(entryToEdit.father_Name_Hin);
      setGender(entryToEdit.gendeR_CODE);
      setGenderName(entryToEdit.gender);
      setOccupation(entryToEdit.occu_Code);
      setoccupationName(entryToEdit.occupation);
      setMobile(entryToEdit.mobile_No);
      setEmail(entryToEdit.email);
      setSelectedDate(entryToEdit.dob ? new Date(entryToEdit.dob) : null); // Convert to Date object if dob is not null
      setHouseNo(entryToEdit.house_no);
      setForm60Date(entryToEdit.form60 ? new Date(entryToEdit.form60) : null); // ✅ correct

      setLocality(entryToEdit.landmark);
      setArea(entryToEdit.street);
      setState(entryToEdit.state);
      setStateName(entryToEdit.stateName);
      setDistrict(entryToEdit.district);
      setDistrictName(entryToEdit.districtName);
      setPincode(entryToEdit.pincode);
      setPanNo(entryToEdit.paN_no);
      setpaN_Form60(entryToEdit.paN_Form60);

      // Set edit mode
      setEditId(entryToEdit.id); // Assuming id_No is the unique identifier
      setIsEditing(true);
    } else {
      console.error("Entry not found for the given ID:", id);
    }
  };

  const handleNameChange = (e) => {
    const raw = e.target.value;
    const cleanedName = raw.replace(/\s+/g, " ").trim();
    setName(cleanedName);

    if (cleanedName) {
      dispatch(
        translateTextAsync({
          text: cleanedName,
          source: "en",
          target: "hi",
          field: "Name",
        })
      );
    } else {
      setHindiName("");
    }
  };

  const handleRelativeChange = (e) => {
    const relative = e.target.value;
    setRelative(relative);
    if (relative) {
      dispatch(
        translateTextAsync({
          text: relative,
          source: "en",
          target: "hi",
          field: "Relative",
        })
      );
    } else {
      setRelativeHindi("");
    }
  };

  const handleOptionChange = (e) => {
    const value = e.target.value;
    setpaN_Form60(value);
    setPanNo("");

    if (value === "form60") {
      setForm60Date(null); // start fresh
    } else {
      setForm60Date(null); // clear previous form60 DOB
    }
  };

  const filteredIdTypeData =
    appointmentType === "V"
      ? idTypeData.filter(
          (option) => option.iD_CODE === "00" || option.iD_CODE === "04"
        ) // Only ADHAAR
      : idTypeData;

  const regexPatterns = {
    "01": /^[A-Z]{3}[0-9]{7}$/, // VOTER ID: Example: ABC1234567
    "02": /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, // PAN CARD: Example: ABCDE1234F
    "03": /^[A-Z]{2}[0-9]{13}$/, // DL: Example: DL0123456789123
    "04": /^[0-9]{12}$/, // ADHAAR: Example: 123456789012
  };

  const handleIDNoChange = (e) => {
    const value = e.target.value.toUpperCase();

    const pattern = regexPatterns[identificationType];
    if (pattern && !pattern.test(value)) {
      setError("Invalid ID No. for " + idName);
    } else {
      setError("");
    }
    setIDNo(value);
  };
  const handleRadioChange = (event) => {
    const value = event.target.value;
    setIsPartySignUpModify(false);
    setConfirmed(value); // Update confirmed state
    dispatch(clearAadhaarDetails());
  };

  useEffect(() => {
    if (confirmed === "no" && !PartySignUpDetails) {
      dispatch(setConfirmedNo());
      dispatch(resetPartySignUpDetails());
      setIsSignUpModalOpen(true); // Open the sign-up modal when confirmed is "no"
      setIsMobileModalOpen(false);
    } else if (confirmed === "yes" && isMobileVerified === false) {
      dispatch(setConfirmedYes());
      dispatch(resetPartySignUpDetails());
      setIsMobileModalOpen(true);
      setIsSignUpModalOpen(false); // Open the mobile verification modal if mobile is not verified
    } else if (
      confirmed === "yes" &&
      isMobileVerified === true &&
      datatableEntries2.length > 0
    ) {
      dispatch(resetPartySignUpDetails());
      setIsMobileModalOpen(false);
    } else {
      setIsMobileModalOpen(false);
    }
  }, [confirmed, isMobileVerified]);

  // trial for refresh before save button and show yes or no radio buttons starts

  useEffect(() => {
    const storedEntries = sessionStorage.getItem("datatableEntries2");

    if (storedEntries) {
      const parsedEntries = JSON.parse(storedEntries);

      // Check if a specific entry is present
      const isEntryPresent = parsedEntries.some(
        (entry) => entry.mobile_No === Mobile
      );

      if (isEntryPresent) {
        setDatatableEntries2(parsedEntries);
      } else {
        resetFormAndShowConfirmation();
      }
    } else {
      resetFormAndShowConfirmation();
    }
  }, []);

  const resetFormAndShowConfirmation = () => {
    dispatch(setisMobileVerified(false));
    dispatch(clearAadhaarDetails());
    dispatch(resetPartySignUpDetails());

    setConfirmed(null); // Show confirmation message
  };

  // trial for refresh before save button and show yes or no radio buttons ends

  return (
    <>
      {/* {confirmed === null && !(isMobileVerified || aadhaarDetails) && ( */}
      {/* {!isEditMode &&
        (confirmed === null ||
          confirmedSlice === null ||
          datatableEntries2.length === 0) &&
        (isMobileVerified === false || !PartySignUpDetails) && ( */}
      {!isEditMode && confirmed === null && !PartySignUpDetails && (
        <div className="flex justify-center items-center py-10 gap-16 3xl:gap-28">
          <div className="confirmation-message bg-[#E8EFF2] p-6 rounded-md shadow-md text-center w-96 3xl:w-1/3 3xl:h-36">
            <p className="text-md font-semibold mt-4">
              Is User Already Registered With UK PDE???
            </p>
            <div className="flex justify-center mt-6 gap-4">
              <label className="flex items-center">
                <input
                  type="radio"
                  name="confirmation"
                  value="yes"
                  className="mr-2"
                  onChange={handleRadioChange}
                />
                Yes
              </label>
              <label className="flex items-center">
                <input
                  type="radio"
                  name="confirmation"
                  value="no"
                  className="mr-2"
                  onChange={handleRadioChange}
                />
                No
              </label>
            </div>
          </div>
          <div className="ml-10">
            <img
              src={partydetailsimg}
              alt="Illustration"
              className="h-64 3xl:h-80"
            />
          </div>
        </div>
      )}

      {/* {isSignUpModalOpen && confirmed !== null && (
        <PartySignUpModal
          isOpen={isSignUpModalOpen}
          onClose={() => {
            setIsSignUpModalOpen(false);
          }}
          isPartySignUpModify={isPartySignUpModify}
          setIsPartySignUpModify={setIsPartySignUpModify}
        />
      )} */}
      {isSignUpModalOpen && confirmed !== null && (
        <PartySignUpModal
          isOpen={isSignUpModalOpen}
          onClose={() => {
            setIsSignUpModalOpen(false);
            setReEkyc(false);
          }}
          isPartySignUpModify={isPartySignUpModify}
          reEkyc={reEkyc}
          setIsPartySignUpModify={setIsPartySignUpModify}
        />
      )}

      {/* Render MobileModal when the modal state is true */}
      {isMobileModalOpen && (
        <MobileModal
          isOpen={isMobileModalOpen}
          onClose={() => setIsMobileModalOpen(false)}
          appointmentType={appointmentType}
          activeTab={"secondParty"}
        />
      )}

      {isPhotoVisible && Photo ? (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center backdrop-blur-md"
          onClick={() => setIsPhotoVisible(false)}
        >
          <div className="w-48 h-48 rounded-full overflow-hidden border-4 border-white shadow-lg bg-white">
            <img
              src={`data:image/jpeg;base64,${Photo}`}
              // src={
              //   PartySignUpDetails[0]?.Photo
              //     ? `data:image/jpeg;base64,${PartySignUpDetails[0]?.Photo}`
              //     : "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
              // }
              alt="User Photo"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      ) : (
        <>
          {((confirmed === "yes" &&
            isMobileVerified &&
            (appointmentType === "P" ||
              (appointmentType === "V" && adhaarEkyc === "Y") ||
              appointmentType === "L")) ||
            (confirmedSlice === null &&
              (isMobileVerified || PartySignUpDetails)) ||
            (confirmed === "no" && PartySignUpDetails) ||
            isEditMode) && (
            <form onSubmit={handleSave}>
              <div className="grid gap-4 m-8 sm:grid-cols-12 grid-cols-2 items-center">
                <label className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1">
                  ID Type:
                </label>
                <div className="block w-full relative sm:col-span-3 grid-cols-1">
                  <select
                    name="identificationType"
                    value={identificationType}
                    disabled
                    // onChange={(e) => setIdentificationType(e.target.value)}
                    onChange={(e) => {
                      const selectedOption = filteredIdTypeData.find(
                        (option) => option.iD_CODE === e.target.value
                      );
                      setIdentificationType(e.target.value);
                      setidName(selectedOption.id); // Set name to the selected option's id
                      setError(""); // Clear any previous errors when ID type changes
                      setIDNo("");
                      resetFields();
                    }}
                    required
                    className="block w-full pl-2 pr-8 py-1.5 border-none bg-gray-100 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  >
                    {/* <option value="">Select</option> */}
                    {filteredIdTypeData.map((option) => (
                      <option key={option.iD_CODE} value={option.iD_CODE}>
                        {option.id}
                      </option>
                    ))}
                  </select>
                  <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                </div>

                <label className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1">
                  ID No.:
                </label>
                <div className="block w-full relative sm:col-span-3 grid-cols-1">
                  <input
                    type="IDNo"
                    id="IDNo"
                    name="IDNo"
                    value={IDNo}
                    disabled
                    onChange={handleIDNoChange}
                    className="uppercase block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                    required
                  />
                  <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />

                  {error && (
                    <p className="text-red-500 text-xs mt-2 absolute">
                      {error}
                    </p>
                  )}
                </div>
                {identificationType === "04" && (
                  <div className="block w-full relative sm:col-span-3 grid-cols-1">
                    <span
                      onClick={handelReEkyc}
                      className="text-black font-semibold"
                    >
                      Re-Ekyc?
                    </span>
                  </div>
                )}
              </div>

              <div className="grid gap-4 m-8 sm:grid-cols-12 grid-cols-2 items-center">
                <label className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1">
                  Name:
                </label>
                <div className="block w-full relative sm:col-span-3 grid-cols-1">
                  <input
                    type="Name"
                    id="Name"
                    name="Name"
                    value={Name}
                    onChange={handleNameChange}
                    className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                    required
                    disabled={identificationType === "04"}
                  />
                  <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                </div>

                <label className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1">
                  नाम:
                </label>
                <div className="block w-full relative sm:col-span-3 grid-cols-1">
                  <input
                    type="HindiName"
                    id="HindiName"
                    name="HindiName"
                    value={HindiName}
                    // onChange={(e) => setHindiName(e.target.value)}
                    // onChange={(e) => {
                    //   const filtered = e.target.value.replace(
                    //     /[^\u0900-\u097F\s]/g,
                    //     ""
                    //   );
                    //   setHindiName(filtered);
                    // }}
                    onChange={(e) => {
                      const raw = e.target.value;
                      const filtered = raw
                        .replace(/[^\u0900-\u097F\s]/g, "")
                        .trimStart();
                      setHindiName(filtered.replace(/\s+/g, " ").trim());
                    }}
                    className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                    required
                    // disabled={identificationType === "04" && aadhaarDetails}
                  />
                  <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                </div>

                <label className="block w-full relative text-sm font-semibold sm:col-span-1">
                  Relation:
                </label>
                <div className="block w-full relative sm:col-span-3">
                  <select
                    name="Relation"
                    value={relation}
                    onChange={(e) => setRelation(e.target.value)}
                    required
                    disabled={identificationType === "04"}
                    className="block w-full pl-2 pr-8 py-1.5 border-none bg-gray-100 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  >
                    {relationData.map((option) => (
                      <option
                        key={option.relatioN_CODE}
                        value={option.relatioN_CODE}
                      >
                        {option.relation}
                      </option>
                    ))}
                  </select>
                  <hr className="absolute left-0  bottom-0 w-full h-0.5 border-none bg-gray-500" />
                </div>
              </div>
              <div className="grid gap-4 m-8 sm:grid-cols-12 grid-cols-2 items-center">
                <label className="block w-full relative text-sm font-semibold sm:col-span-1">
                  Relative Name:
                </label>
                <div className="block w-full relative sm:col-span-3">
                  <input
                    type="text"
                    id="Relative"
                    name="Relative"
                    value={Relative}
                    onChange={handleRelativeChange}
                    disabled={identificationType === "04"}
                    className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                    required
                  />
                  <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                </div>

                <label className="block w-full relative text-sm font-semibold sm:col-span-1">
                  रिश्तेदार:
                </label>
                <div className="block w-full relative sm:col-span-3">
                  <input
                    type="text"
                    id="RelativeHindi"
                    name="RelativeHindi"
                    value={RelativeHindi}
                    onChange={(e) => {
                      const filtered = e.target.value.replace(
                        /[^\u0900-\u097F\s]/g,
                        ""
                      );
                      setRelativeHindi(filtered);
                    }}
                    className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                    required
                  />
                  <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                </div>
                <label className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1">
                  Gender:
                </label>
                <div className="block w-full relative sm:col-span-3 grid-cols-1">
                  <select
                    name="Gender"
                    value={Gender}
                    onChange={handleGenderChange}
                    disabled={identificationType === "04"}
                    required
                    className="block w-full pl-2 pr-8 py-1.5 border-none bg-gray-100 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  >
                    {Array.isArray(genderData) &&
                      genderData.map((option) => (
                        <option
                          key={option.gendeR_CODE}
                          value={option.gendeR_CODE}
                        >
                          {option.gender}
                        </option>
                      ))}
                  </select>
                  <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                </div>
              </div>
              <div className="grid gap-4 m-8 sm:grid-cols-12 grid-cols-2 items-center">
                <label className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1">
                  Occupation:
                </label>
                <div className="block w-full relative sm:col-span-3 grid-cols-1">
                  <select
                    name="Occupation"
                    value={Occupation}
                    // onChange={(e) => setOccupation(e.target.value)}
                    onChange={(e) => {
                      const selectedOption = occupationData.find(
                        (option) => option.occupatioN_CODE === e.target.value
                      );
                      setOccupation(e.target.value);
                      setoccupationName(selectedOption.occupation); // Set name to the selected option's id
                    }}
                    required
                    className="block w-full pl-2 pr-8 py-1.5 border-none bg-gray-100 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  >
                    {/* <option value="">Mode Of Payment</option> */}
                    {/* <option value="" disabled>
                      Select occupation
                    </option> */}
                    {occupationData.map((option) => (
                      <option
                        key={option.occupatioN_CODE}
                        value={option.occupatioN_CODE}
                      >
                        {option.occupation}
                      </option>
                    ))}
                  </select>
                  <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                </div>

                <label className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1">
                  Mobile No:
                </label>
                <div className="block w-full relative sm:col-span-3 grid-cols-1">
                  <input
                    type="text"
                    id="Mobile"
                    name="Mobile"
                    value={Mobile}
                    maxLength={10}
                    // onChange={(e) => setMobile(e.target.value)}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only digits and limit to 10 characters
                      if (/^\d*$/.test(value) && value.length <= 10) {
                        setMobile(value);
                      }
                    }}
                    className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                    required
                  />
                  <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                </div>
                <label className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1">
                  <input
                    type="radio"
                    name="formType"
                    value="form60"
                    checked={
                      isModifying
                        ? paN_Form60 === "form60"
                        : paN_Form60 === "form60"
                    }
                    onChange={handleOptionChange}
                  />
                  <span className="ml-1">Form 60</span>
                </label>
                <label className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1">
                  <input
                    type="radio"
                    name="formType"
                    value="PAN"
                    checked={
                      isModifying ? paN_Form60 === "PAN" : paN_Form60 === "PAN"
                    }
                    onChange={handleOptionChange}
                  />
                  <span className="ml-1">PAN no</span>
                </label>
                {/* {paN_Form60 === "form60" && (
                  <div className="block w-full relative sm:col-span-2 grid-cols-1">
                    <input
                      type="date"
                      name="selectedDate"
                      value={
                        selectedDate
                          ? selectedDate.toISOString().split("T")[0]
                          : ""
                      }
                      onChange={(e) =>
                        setSelectedDate(new Date(e.target.value))
                      }
                      className="block w-full pl-2 pr-8 py-1.5 border-none bg-gray-100 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    />
                    <hr className="absolute left-0 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                  </div>
                )} */}
                {paN_Form60 === "form60" && (
                  <div className="block w-full relative sm:col-span-2 grid-cols-1">
                    <input
                      type="date"
                      name="form60Date"
                      value={
                        form60Date ? form60Date.toISOString().split("T")[0] : ""
                      }
                      onChange={(e) => setForm60Date(new Date(e.target.value))}
                      className="block w-full pl-2 pr-8 py-1.5 border-none bg-gray-100 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    />
                    <hr className="absolute left-0 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                  </div>
                )}

                {paN_Form60 === "PAN" && (
                  <div className="block w-full relative sm:col-span-2 grid-cols-1">
                    {/* Render your PAN specific input or modify as needed */}
                    <input
                      type="text"
                      name="paN_no"
                      placeholder="Enter PAN number"
                      value={paN_no}
                      maxLength={10}
                      // onChange={(e) => setPanNo(e.target.value)}
                      onChange={(e) => {
                        const value = e.target.value.toUpperCase(); // Convert input to uppercase
                        // Allow partial inputs, but set value only if it matches the complete PAN format
                        if (/^[A-Z0-9]*$/.test(value)) {
                          setPanNo(value);
                        }
                      }}
                      className="block w-full pl-2 pr-8 py-1.5 border-none bg-gray-100 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    />
                    <hr className="absolute left-0 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                  </div>
                )}
              </div>
              <div className="grid gap-4 m-8 sm:grid-cols-12 grid-cols-2 items-center">
                <label className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1">
                  Email:
                </label>
                <div className="block w-full relative sm:col-span-3 grid-cols-1">
                  <input
                    type="Email"
                    id="Email"
                    Email="Email"
                    value={Email}
                    placeholder="abc@example.com"
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only digits and limit to 10 characters
                      if (/^[a-zA-Z0-9]+@(?:[a-zA-Z0-9]+\.)+[A-Za-z]+$/) {
                        setEmail(value);
                      }
                    }}
                    className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                    required
                    // disabled={identificationType === "04"}
                  />
                  <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                </div>
                <span
                  onClick={() => setIsPhotoVisible(true)}
                  className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1 text-blue-300"
                >
                  View Photo
                </span>{" "}
                <div className="block w-full relative sm:col-span-3 grid-cols-1"></div>
                <label className="block w-full relative text-sm font-semibold sm:col-span-1"></label>
                <div className="block w-full relative sm:col-span-3"></div>
              </div>

              <div className="grid gap-2 m-8 sm:grid-cols-11 items-center">
                <label className="block w-full relative text-sm font-semibold sm:col-span-1">
                  Address:
                </label>

                {[
                  { id: "HouseNo", value: HouseNo, setValue: setHouseNo },
                  { id: "Locality", value: Locality, setValue: setLocality },
                  { id: "Area", value: Area, setValue: setArea },
                ].map(({ id, value, setValue }) => (
                  <div key={id} className="block w-full relative sm:col-span-3">
                    <label
                      htmlFor={id}
                      className="absolute left-4 -top-2.5 text-gray-400 text-sm font-serif px-1"
                    >
                      {id}
                    </label>
                    <input
                      type="text"
                      id={id}
                      name={id}
                      value={value}
                      onChange={(e) => setValue(e.target.value)}
                      disabled={identificationType === "04"}
                      className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                      required
                    />
                    <hr className="absolute left-0 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                  </div>
                ))}
              </div>

              <div className="grid gap-2 m-8 sm:grid-cols-11 items-center">
                <label className="block w-full relative text-sm font-semibold sm:col-span-1"></label>

                {[
                  {
                    id: "State",
                    value: State,
                    onChange: handleStateChange,
                    options: stateOptions,
                  },
                  {
                    id: "District",
                    value: district,
                    onChange: handleDistrictChange,
                    options: districtOptions,
                  },
                ].map(({ id, value, onChange, options }) => (
                  <div key={id} className="block w-full relative sm:col-span-3">
                    <label
                      htmlFor={id}
                      className="absolute left-4 -top-2.5 text-gray-400 text-sm font-serif px-1"
                    >
                      {id}
                    </label>
                    <select
                      id={id}
                      className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                      value={value}
                      onChange={onChange}
                      required
                    >
                      <option value="">{id}</option>
                      {options.map((option) => (
                        <option
                          key={option[`${id.toLowerCase()}ID`]}
                          value={option[`${id.toLowerCase()}ID`]}
                        >
                          {option[`${id.toLowerCase()}Name`]}
                        </option>
                      ))}
                    </select>
                    <hr className="absolute left-0 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                  </div>
                ))}

                <div className="block w-full relative sm:col-span-3">
                  <label
                    htmlFor="Pincode"
                    className="absolute left-4 -top-2.5 text-gray-400 text-sm font-serif px-1"
                  >
                    Pincode
                  </label>
                  <input
                    type="tel"
                    id="Pincode"
                    name="Pincode"
                    placeholder="Pincode"
                    value={Pincode}
                    maxLength={6}
                    minLength={6}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d{0,6}$/.test(value)) {
                        setPincode(value);
                      }
                    }}
                    disabled={identificationType === "04"}
                    className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                    required
                  />
                  <hr className="absolute left-0 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                </div>
              </div>

              {appointmentType === "L" && (
                <div className="grid gap-4 m-8 sm:grid-cols-12 items-center">
                  <label className="block text-sm font-semibold sm:col-span-1">
                    Registration For:
                  </label>
                  <div className="sm:col-span-11 flex gap-6">
                    {["Self", "Minor", "POA"].map((label) => (
                      <label
                        key={label}
                        className="flex items-center gap-2 text-sm"
                      >
                        <input
                          type="radio"
                          name="regRadio"
                          value={label}
                          onChange={(e) => {
                            const selected = e.target.value;

                            // ✅ Clear POA-related fields on any change
                            setPOADate("");
                            setOffice("");
                            setDocumentNo("");
                            setPOAYear("");

                            // ✅ Then set selected value and Reg_Code
                            setRegistration_For(selected);

                            if (selected === "Self") {
                              setReg_Code("01");
                            } else if (selected === "Minor") {
                              setReg_Code("02");
                            } else if (selected === "POA") {
                              setReg_Code("03");
                            }
                          }}
                        />
                        {label}
                      </label>
                    ))}
                  </div>
                </div>
              )}

              {appointmentType === "L" && Registration_For === "POA" && (
                <div className="grid gap-2 m-8 sm:grid-cols-10 items-center">
                  <label className="block w-full relative text-sm font-semibold sm:col-span-1">
                    POA Details:
                  </label>

                  {[
                    { id: "POADate", value: POADate, setValue: setPOADate },
                    { id: "Office", value: Office, setValue: setOffice },
                    {
                      id: "DocumentNo",
                      value: DocumentNo,
                      setValue: setDocumentNo,
                    },
                    { id: "POAYear", value: POAYear, setValue: setPOAYear },
                  ].map(({ id, value, setValue }) => (
                    <div
                      key={id}
                      className="block w-full relative sm:col-span-2"
                    >
                      <label
                        htmlFor={id}
                        className="absolute left-4 -top-2.5 text-gray-400 text-sm font-serif px-1"
                      >
                        {id}
                      </label>
                      <input
                        type={id === "POADate" ? "date" : "text"}
                        id={id}
                        name={id}
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                        className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                        required
                      />
                      <hr className="absolute left-0 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                    </div>
                  ))}
                </div>
              )}

              <div className="flex justify-center mt-5 gap-4">
                <button
                  className="px-6 py-1.5 m-2 bg-blue-500 text-white rounded-full text-md"
                  // onClick={handleSave}
                  type="submit"
                >
                  Add
                </button>

                <button
                  className="px-6 py-1.5 m-2 bg-blue-500 text-white rounded-full text-md"
                  onClick={onNext}
                >
                  Next
                </button>
              </div>
            </form>
          )}
        </>
      )}

      <div className="flex justify-center m-3 gap-4">
        <Datatable
          entries={datatableEntries2}
          onDelete={handleDelete}
          onEdit={handleEdit}
          appointmentType={appointmentType}
          activeTab={"secondParty"}
        />
      </div>
      <AadhaarOTPModal
        isOpen={showOtpForm}
        onClose={() => setShowOtpForm(false)}
      />
    </>
  );
};

const WitnessForm = ({ onNext }) => {
  const { relationData, occupationData, idTypeData, genderData } = useSelector(
    (state) => state.PartyDetail
  );

  const appointmentType = useSelector(
    (state) => state.Procedure.appointmentType
  );
  const adhaarEkyc = useSelector(selectAdhaarEkyc);

  const pde = useSelector(selectPdEId);
  const pdeInfo = useSelector(selectPDEInfo);
  const pdeData = pdeInfo?.pdeData[0];
  // const pdeMod = pdeData?.pdE_ID;
  const partyDetails = pdeInfo?.partyDetails[0];
  const procedureMod = useSelector(selectProcedureMod);
  const prevProcType = pdeInfo?.pdeData[0]?.appointment_Type;

  const translatedText = useSelector(selectTranslatedText);
  const firstParty = useSelector(selectFirstParty);
  const secondParty = useSelector(selectSecondParty);
  const witness = useSelector(selectWitness);
  const idProofOptions = useSelector(selectIdProofOptions);
  const aadhaarDetails = useSelector(selectAadhaarDetails);
  const [identificationType, setIdentificationType] = useState("");
  const [IDNo, setIDNo] = useState("");
  const [idName, setidName] = useState("");
  const dispatch = useDispatch();
  const [showOtpForm, setShowOtpForm] = useState(false);

  const [Name, setName] = useState("");
  const [HindiName, setHindiName] = useState("");
  const [relation, setRelation] = useState("");
  const [Relative, setRelative] = useState("");
  const [RelativeHindi, setRelativeHindi] = useState("");
  const [Gender, setGender] = useState("");
  const [GenderName, setGenderName] = useState("");
  const [Occupation, setOccupation] = useState("");
  const [occupationName, setoccupationName] = useState("");
  const [Mobile, setMobile] = useState("");
  const [Email, setEmail] = useState("");
  const [Photo, setPhoto] = useState("");
  const [isPhotoVisible, setIsPhotoVisible] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [HouseNo, setHouseNo] = useState("");
  const [Locality, setLocality] = useState("");
  const [Area, setArea] = useState("");
  const [State, setState] = useState("");
  const [district, setDistrict] = useState("");

  const [stateName, setStateName] = useState("");
  const [districtName, setDistrictName] = useState("");
  const [Pincode, setPincode] = useState("");
  const [datatableEntriesWitness, setDatatableEntriesWitness] = useState([]);
  const navigate = useNavigate();
  const stateOptions = useSelector(selectStateOptions);
  const districtOptions = useSelector(selectDistrictOptions);
  const [isEditing, setIsEditing] = useState(false);
  const [editId, setEditId] = useState(null);
  const isModifying = useSelector(selectIsModifying);
  const [error, setError] = useState("");
  const [confirmed, setConfirmed] = useState(null);
  const [isSignUpModalOpen, setIsSignUpModalOpen] = useState(false);
  const [isMobileModalOpen, setIsMobileModalOpen] = useState(false);
  const PartySignUpDetails = useSelector(selectPartySignUpDetails);
  const [isEditMode, setIsEditMode] = useState(false);
  const isOTPVerified = useSelector(selectIsOTPVerified);
  const isMobileVerified = useSelector(selectisMobileVerified);
  const confirmedSlice = useSelector(selectConfirmed);
  const [isPartySignUpModify, setIsPartySignUpModify] = useState(false);
  const [reEkyc, setReEkyc] = useState(false);

  useEffect(() => {
    if (confirmedSlice === null) {
      setConfirmed(confirmedSlice);
    }
  }, [confirmedSlice]);

  useEffect(() => {
    if (
      PartySignUpDetails &&
      adhaarEkyc === "N" &&
      PartySignUpDetails[0]?.identificationType !== "04" &&
      (appointmentType === "V" || appointmentType === "VI") &&
      confirmed !== null &&
      isOTPVerified === false
    ) {
      setIsMobileModalOpen(false);
      // dispatch(setConfirmedNo());
      dispatch(clearAadhaarDetails());
      setIsPartySignUpModify(true);
      setIsSignUpModalOpen(true);
      setisMobileVerified(false);
    }
  });

  useEffect(() => {
    if (
      PartySignUpDetails &&
      adhaarEkyc === "N" &&
      (appointmentType === "V" || appointmentType === "VI")
    ) {
      setIsMobileModalOpen(false);
      setIsPartySignUpModify(true);
      setIsSignUpModalOpen(true);
      dispatch(resetPartySignUpDetails());
      // dispatch(setConfirmedNo());
      dispatch(clearAadhaarDetails());
      // dispatch(resetConfirmed());
      setisMobileVerified(false);
    }
  }, [PartySignUpDetails, appointmentType, confirmed, isMobileVerified]);

  useEffect(() => {
    dispatch(fetchStateDataAsync());
    dispatch(fetchGender());
    dispatch(fetchIDTypeData());
    dispatch(fetchOccupationData());
    if (State) {
      dispatch(fetchDistrictData(State));
    }
  }, [dispatch]);

  const handleStateChange = (e) => {
    //;
    const stateId = e.target.value; // This is a string from the select input
    setState(stateId); // Set the state ID

    // Ensure that stateOptions is an array before proceeding
    if (Array.isArray(stateOptions)) {
      const selectedState = stateOptions.find(
        (option) => option.stateID.toString() === stateId // Convert stateID to string for comparison
      );

      //console.log("State ID from select:", stateId);
      //console.log("Selected State:", selectedState);

      setStateName(selectedState ? selectedState.stateName : ""); // Set the state name

      if (selectedState) {
        dispatch(fetchDistrictDataAsync(stateId)); // Fetch district data if a state is selected
      }
    } else {
      console.error("stateOptions is not an array or is undefined");
    }
  };

  const handleDistrictChange = (e) => {
    const districtID = e.target.value; // This is a string from the select input
    setDistrict(districtID); // Set the state ID

    // Ensure that stateOptions is an array before proceeding
    if (Array.isArray(districtOptions)) {
      const selectedDistrict = districtOptions.find(
        (option) => option.districtID.toString() === districtID
      );
      setDistrictName(selectedDistrict ? selectedDistrict.districtName : "");
    } else {
      console.error("stateOptions is not an array or is undefined");
    }
  };

  useEffect(() => {
    const storedEntries = sessionStorage.getItem("datatableEntriesWitness");
    if (storedEntries) {
      setDatatableEntriesWitness(JSON.parse(storedEntries));
    }
  }, []);

  useEffect(() => {
    if (pde || PartySignUpDetails) {
      dispatch(fetchPDEInfoAsync(pde));
      dispatch(fetchRelationData());
      dispatch(fetchIDTypeData());
    }
  }, [dispatch, pde, PartySignUpDetails]);

  useEffect(() => {
    if (
      PartySignUpDetails?.length &&
      ((appointmentType === "V" && adhaarEkyc === "Y") ||
        appointmentType === "P" ||
        appointmentType === "L")
    ) {
      const firstDetail = PartySignUpDetails[0];
      setIdentificationType(firstDetail.identificationType || "");
      setIDNo(firstDetail.identificationNumber || "");
      setName(firstDetail.name || "");
      setRelation(firstDetail.relationShip);
      setRelative(firstDetail.father_Mother_guardian_Name || "");
      setGender(firstDetail.addGender || "");
      setMobile(firstDetail.mobileNo || "");
      setHouseNo(firstDetail.addHousenoFlat || "");
      setLocality(firstDetail.addBuilding_Landmark || "");
      setArea(firstDetail.addAreaLocality || "");
      setState(firstDetail.addState || "");
      setDistrict(firstDetail.addDistrict || "");
      setPincode(firstDetail.addPinCode || "");
      setEmail(firstDetail.email || "");
      setPhoto(firstDetail.photo || "");
      // Set the stateName based on the selected State

      const selectedState = stateOptions.find(
        (option) => option.stateID.toString() === PartySignUpDetails[0].addState // Convert stateID to string for comparison
      );

      //console.log("State ID from select:", PartySignUpDetails[0].addState);
      //console.log("Selected State:", selectedState);

      setStateName(selectedState ? selectedState.stateName : ""); // Set the state name
      if (selectedState) {
        dispatch(fetchDistrictDataAsync(selectedState)); // Fetch district data if a state is selected
      }

      // Set the districtName based on the selected District
      const selectedDistrict = districtOptions.find(
        (option) =>
          option.districtID.toString() === PartySignUpDetails[0].addDistrict
      );
      // console.log(
      //   "District ID from select:",
      //   PartySignUpDetails[0].addDistrict
      // );
      // console.log("Selected District:", selectedDistrict);

      setDistrictName(selectedDistrict ? selectedDistrict.districtName : "");

      if (PartySignUpDetails[0].addGender === "01") {
        setGender("01");
        setGenderName("Male");
      }
      if (PartySignUpDetails[0].addGender === "02") {
        setGender("02");
        setGenderName("Female");
      }
      if (PartySignUpDetails[0].addGender === "03") {
        setGender("03");
        setGenderName("Transgender");
      }
      // Translate Name and Relative Name
      if (PartySignUpDetails[0].name) {
        dispatch(
          translateTextAsync({
            text: PartySignUpDetails[0].name,
            source: "en",
            target: "hi",
            field: "Name",
          })
        );
      }
      if (PartySignUpDetails[0].father_Mother_guardian_Name) {
        dispatch(
          translateTextAsync({
            text: PartySignUpDetails[0].father_Mother_guardian_Name,
            source: "en",
            target: "hi",
            field: "Relative",
          })
        );
      }
    }
  }, [
    isOTPVerified,
    // aadhaarDetails,
    // identificationType,
    PartySignUpDetails,
    stateOptions, // Make sure stateOptions and districtOptions are available here
    districtOptions,
    dispatch,
  ]);

  useEffect(() => {
    ////;
    if (translatedText) {
      setHindiName(translatedText.Name || "");
      setRelativeHindi(translatedText.Relative || "");
    }
  }, [translatedText]);

  const handelReEkyc = () => {
    setReEkyc(true);
    setIsPartySignUpModify(true);
    setIsSignUpModalOpen(true);
  };

  const validateInputs = () => {
    // const idNoRegex = /^[0-9]{12}$/; // Example regex for a 12-digit ID number
    const mobileRegex = /^[0-9]{10}$/; // Regex for a 10-digit mobile number
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/; // Regex for PAN number format
    // const emailRegex = /^[a-zA-Z0-9]+@(?:[a-zA-Z0-9]+\.)+[A-Za-z]+$/;
    const emailRegex =
      /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    if (!mobileRegex.test(Mobile)) {
      toast.error("Please enter a valid mobile number (10 digits).");
      return false;
    }

    if (!emailRegex.test(Email)) {
      toast.error("Please enter a valid Email");
      return false;
    }

    if (!Occupation) {
      toast.error("Please select an occupation.");
      return false;
    }

    if (!selectedDate) {
      toast.error("Please select D.O.B");
      return false;
    }

    return true;
  };

  const handleGenderChange = (e) => {
    const selectedGenderCode = e.target.value;
    setGender(selectedGenderCode); // Set the gender code
    const selectedGender = genderData.find(
      (option) => option.gendeR_CODE === selectedGenderCode
    );
    setGenderName(selectedGender ? selectedGender.gender : ""); // Set the gender name
  };

  const resetFields = () => {
    setName("");
    setHindiName("");
    setRelation("");
    setRelative("");
    setRelativeHindi("");
    setGender("");
    setGenderName("");
    setOccupation("");
    setoccupationName("");
    setMobile("");
    setSelectedDate("");
    setHouseNo("");
    setLocality("");
    setArea("");
    setState("");
    setStateName("");
    setDistrict("");
    setDistrictName("");
    setPincode("");
    setEmail("");
  };

  const handleAdd = (e) => {
    const pattern = regexPatterns[identificationType];
    e.preventDefault(); // Prevent default form submission
    if (!validateInputs()) {
      return;
    } // Check inputs before proceeding
    if (pattern && !pattern.test(IDNo)) {
      setError("Invalid ID No. for " + idName);
      return; // Prevent form submission
    }

    const newData = {
      id: isEditing ? editId : uuidv4(),
      id_No: IDNo,
      idName: PartySignUpDetails
        ? filteredIdTypeData.find(
            (option) => option.iD_CODE === identificationType
          )?.id || ""
        : idName, // Conditionally set idName
      id_Type_Code: identificationType,
      name_Eng: Name,
      name_Hin: HindiName,
      relation: relation,
      father_Name_Eng: Relative,
      father_Name_Hin: RelativeHindi,
      gender: GenderName,
      gendeR_CODE: Gender,
      vtc: "",
      form60: "",
      occu_Code: Occupation,
      occupation: occupationName,
      mobile_No: Mobile,
      email: Email,
      dob: selectedDate ? selectedDate.toISOString().split("T")[0] : null,
      country: "India",
      house_no: HouseNo,
      landmark: Locality,
      street: Area,
      state: State,
      stateName: stateName,
      district: district,
      districtName: districtName,
      pincode: Pincode,
      photo: Photo || null,
    };
    const updatedEntries = isEditing
      ? datatableEntriesWitness.map((entry) =>
          entry.id === editId ? newData : entry
        )
      : [...datatableEntriesWitness, newData];

    //console.log("After update:");
    //console.log("updatedEntries:", updatedEntries);

    setDatatableEntriesWitness(updatedEntries);
    sessionStorage.setItem(
      "datatableEntriesWitness",
      JSON.stringify(updatedEntries)
    );

    dispatch(setWitnessDetails(updatedEntries));

    // Clear form fields after saving
    setIDNo("");
    setIdentificationType("");
    setidName("");
    setEditId(null);
    setIsEditing(false);
    dispatch(clearAadhaarDetails());
    dispatch(resetPartySignUpDetails());
    //console.log(PartySignUpDetails);
    dispatch(setisMobileVerified(false));
    setConfirmed(null);
    dispatch(clearTranslation());
    dispatch(resetConfirmed());
    resetFields();
    setIsEditMode(false);
    setIsPartySignUpModify(false);
  };

  // const handleSave = async () => {

  //   if (procedureMod && prevProcType !== appointmentType) {
  //     dispatch(modifyAppointmentType({ pde, appointmentType }));
  //   }

  //   if (pde) {
  //     dispatch(
  //       updateAppointmentType({ pde, appointmentType: appointmentType })
  //     );
  //   }
  //   if (!firstParty || Object.keys(firstParty).length === 0) {
  //     toast.warning("Please add at least one first party entry before saving.");
  //     return;
  //   }

  //   if (datatableEntriesWitness.length < 2) {
  //     toast.warning("Please add at least two witness entries before saving.");
  //     return;
  //   }

  //   try {
  //     //;
  //     if (firstParty && secondParty) {
  //       const partyDetails = {
  //         pdE_id: pde,
  //         savefirstparty: firstParty,
  //         savesecondparty: secondParty,
  //         savewitness: datatableEntriesWitness,
  //       };
  //       const response = await dispatch(
  //         InsertPartyDetailsPaperLess(partyDetails)
  //       ).unwrap();
  //       //console.log("P A R T Y:", response[0].pdE_ID);
  //       if (response[0].pdE_ID) {
  //         toast.success(" paper less inserted");
  //         debugger;
  //         if (appointmentType) {
  //           const res = await axiosInstance.get(
  //             `/PartyDetails/InsertPDEPaperless?PDE_ID=${response[0].pdE_ID}&apptype=${appointmentType}`
  //           );
  //           if (res.status === 200) {
  //             toast.success("Paperless Inserted");
  //           } else {
  //             toast.error("Error in paperless");
  //           }
  //         }
  //         await dispatch(nextStep());
  //         await dispatch(completeStep({ step: 3, completed: true }));
  //         dispatch(setModifying(true));
  //         if (appointmentType === "P") {
  //           navigate("/OnlinePayment");
  //         } else {
  //           navigate("/UploadDocument");
  //         }
  //       } else {
  //         toast.error("Error Saving PartyDetails");
  //       }

  //       // if (appointmentType === "L") {
  //       //   const response = await dispatch(
  //       //     InsertPartyDetailsPaperLess(partyDetails)
  //       //   ).unwrap();
  //       //   //console.log("P A R T Y:", response[0].pdE_ID);
  //       //   if (response[0].pdE_ID) {
  //       //     toast.success(" paper less inserted");

  //       //     if (appointmentType) {
  //       //       const res = await axios.get(
  //       //         `${API_BASE_URL}/PartyDetails/InsertPDEPaperless?PDE_ID=${response[0].pdE_ID}&apptype=${appointmentType}`
  //       //       );
  //       //       if (res.status === 200) {
  //       //         toast.success("Paperless Inserted");
  //       //       } else {
  //       //         toast.error("Error in paperless");
  //       //       }
  //       //     }
  //       //     await dispatch(nextStep());
  //       //     await dispatch(completeStep({ step: 3, completed: true }));
  //       //     dispatch(setModifying(true));
  //       //     navigate("/OnlinePayment");
  //       //   } else {
  //       //     toast.error("Error Saving PartyDetails");
  //       //   }
  //       // } else {
  //       //   const response = await dispatch(
  //       //     InsertPartyDetails(partyDetails)
  //       //   ).unwrap();
  //       //   ;
  //       //   //console.log("P A R T Y:", response[0].pdE_ID);
  //       //   if (response[0].pdE_ID) {
  //       //     toast.success("simple inserted");
  //       //     ;
  //       //     if (appointmentType) {
  //       //       const res = await axios.get(
  //       //         `${API_BASE_URL}/PartyDetails/InsertPDEPaperless?PDE_ID=${response[0].pdE_ID}&apptype=${appointmentType}`
  //       //       );
  //       //       if (res.status === 200) {
  //       //         toast.success("Paperless Inserted");
  //       //       } else {
  //       //         toast.error("Error in paperless");
  //       //       }
  //       //     }
  //       //     await dispatch(nextStep());
  //       //     await dispatch(completeStep({ step: 3, completed: true }));
  //       //     dispatch(setModifying(true));
  //       //     navigate("/OnlinePayment");
  //       //   } else {
  //       //     toast.error("Error Saving PartyDetails");
  //       //   }
  //       // }
  //     }
  //   } catch (error) {
  //     console.error("Error inserting party details:", error);
  //     toast.error("Failed to insert party details. Please try again.");
  //   }
  // };

  const handleSave = async () => {
    // 0) Validate appointmentType up-front
    if (!appointmentType) {
      toast.error("Please select an appointment type before saving.");
      return;
    }

    // 1) Optional: record any intended change, but don't rely on it for the value you send now
    if (procedureMod && prevProcType !== appointmentType) {
      dispatch(modifyAppointmentType({ pde, appointmentType }));
    }
    if (pde) {
      dispatch(updateAppointmentType({ pde, appointmentType }));
    }

    // 2) Required data guards (these are your current early returns)
    if (!firstParty || Object.keys(firstParty).length === 0) {
      toast.warning("Please add at least one first party entry before saving.");
      return;
    }
    if (datatableEntriesWitness.length < 2) {
      toast.warning("Please add at least two witness entries before saving.");
      return;
    }

    try {
      // 3) Proceed even if secondParty is an empty array; only block if it's truly undefined/null
      if (!secondParty) {
        toast.error("Second party state is not initialized.");
        return;
      }

      const partyDetails = {
        pdE_id: pde,
        savefirstparty: firstParty,
        savesecondparty: secondParty,
        savewitness: datatableEntriesWitness,
      };

      const response = await dispatch(
        InsertPartyDetailsPaperLess(partyDetails)
      ).unwrap();

      const insertedId = response?.[0]?.pdE_ID;
      if (!insertedId) {
        toast.error("Error Saving PartyDetails (no PDE_ID).");
        return;
      }

      // 4) Always call Paperless API now that we have insertedId and a validated appointmentType
      const res = await axiosInstance.get(
        `/PartyDetails/InsertPDEPaperless?PDE_ID=${insertedId}&apptype=${appointmentType}`
      );

      if (res.status === 200) {
        toast.success("Paperless Inserted");
      } else {
        toast.error("Error in paperless");
      }

      await dispatch(nextStep());
      await dispatch(completeStep({ step: 3, completed: true }));
      dispatch(setModifying(true));

      if (appointmentType === "P") {
        navigate("/OnlinePayment");
      } else {
        navigate("/UploadDocument");
      }
    } catch (error) {
      console.error("Error inserting party details:", error);
      toast.error("Failed to insert party details. Please try again.");
    }
  };

  const handleDelete = (id) => {
    //console.log("Deleting item with ID:", id);

    // Ensure `id` is a string or match the format of `datatableEntries` ids
    const idToDelete = id.id || id; // Use `id.id` if `id` is an object

    // Filter out the entry with the matching `id`
    const updatedEntries = datatableEntriesWitness.filter(
      (entry) => entry.id !== idToDelete
    );

    //console.log("Updated Entries after delete:", updatedEntries);

    setDatatableEntriesWitness(updatedEntries);
    dispatch(setWitnessDetails(updatedEntries));
    sessionStorage.setItem(
      "datatableEntriesWitness",
      JSON.stringify(updatedEntries)
    );
    dispatch(clearTranslation());
  };

  const handleEdit = (id) => {
    setIsEditMode(true);
    // Find the entry to edit based on the ID provided
    const entryToEdit = datatableEntriesWitness.find(
      (entry) => entry.id === id
    );

    //console.log("Editing entry with ID:", id);
    //console.log("Current DataTable Entries:", datatableEntriesWitness);

    // Log details of each entry for debugging
    datatableEntriesWitness.forEach((entry) => {
      //console.log("Entry keys:", Object.keys(entry)); // Log the keys of the entry
      //console.log("Entry values:", entry); // Log the entire entry object
    });

    // Check if the entry was found
    //console.log("Entry to edit:", entryToEdit);
    if (entryToEdit) {
      // Populate form fields with the entry data
      setIDNo(entryToEdit.id_No);
      setIdentificationType(entryToEdit.id_Type_Code);
      setidName(entryToEdit.idName);
      setName(entryToEdit.name_Eng);
      setHindiName(entryToEdit.name_Hin);
      setRelation(entryToEdit.relation);
      setRelative(entryToEdit.father_Name_Eng);
      setRelativeHindi(entryToEdit.father_Name_Hin);
      setGender(entryToEdit.gendeR_CODE);
      setGenderName(entryToEdit.gender);
      setOccupation(entryToEdit.occu_Code);
      setoccupationName(entryToEdit.occupation);
      setMobile(entryToEdit.mobile_No);
      setEmail(entryToEdit.email);
      setSelectedDate(entryToEdit.dob ? new Date(entryToEdit.dob) : null); // Convert to Date object if dob is not null
      setHouseNo(entryToEdit.house_no);
      setLocality(entryToEdit.landmark);
      setArea(entryToEdit.street);
      setState(entryToEdit.state);
      setStateName(entryToEdit.stateName);
      setDistrict(entryToEdit.district);
      setDistrictName(entryToEdit.districtName);
      setPincode(entryToEdit.pincode);
      // Set edit mode
      setEditId(entryToEdit.id); // Assuming id_No is the unique identifier
      setIsEditing(true);
    } else {
      console.error("Entry not found for the given ID:", id);
    }
  };

  // const handleNameChange = (e) => {
  //   const name = e.target.value;
  //   setName(name);
  //   if (name) {
  //     dispatch(
  //       translateTextAsync({
  //         text: name,
  //         source: "en",
  //         target: "hi",
  //         field: "Name",
  //       })
  //     );
  //   } else {
  //     setHindiName("");
  //   }
  // };

  const handleNameChange = (e) => {
    const raw = e.target.value;
    const cleanedName = raw.replace(/\s+/g, " ").trim();
    setName(cleanedName);

    if (cleanedName) {
      dispatch(
        translateTextAsync({
          text: cleanedName,
          source: "en",
          target: "hi",
          field: "Name",
        })
      );
    } else {
      setHindiName("");
    }
  };

  const handleRelativeChange = (e) => {
    const relative = e.target.value;
    setRelative(relative);
    if (relative) {
      dispatch(
        translateTextAsync({
          text: relative,
          source: "en",
          target: "hi",
          field: "Relative",
        })
      );
    } else {
      setRelativeHindi("");
    }
  };

  const handleUpdate = async () => {
    // if (procedureMod && prevProcType === "P" && appointmentType === "V") {
    //   dispatch(
    //     modifyAppointmentType({ pde, appointmentType: appointmentType })
    //   );
    // }

    // if (
    //   procedureMod &&
    //   prevProcType === "V" &&
    //   appointmentType === "P" &&
    //   appointmentType === "L"
    // ) {
    //   dispatch(
    //     modifyAppointmentType({ pde, appointmentType: appointmentType })
    //   );
    // }

    if (procedureMod && prevProcType !== appointmentType) {
      dispatch(modifyAppointmentType({ pde, appointmentType }));
    }

    if (pde) {
      dispatch(
        updateAppointmentType({ pde, appointmentType: appointmentType })
      );
    }
    if (!firstParty || Object.keys(firstParty).length === 0) {
      toast.warning("Please add at least one first party entry before saving.");
      return;
    }

    if (datatableEntriesWitness.length < 2) {
      toast.warning("Please add at least two witness entries before saving.");
      return;
    }

    //console.log("update is clicked");
    try {
      if (firstParty && secondParty) {
        const partyDetails = {
          pdE_id: pde,
          savefirstparty: firstParty,
          savesecondparty: secondParty,
          savewitness: datatableEntriesWitness,
        };
        const response = await dispatch(
          ModifyPartyDetailsPaperless(partyDetails)
        ).unwrap();
        //console.log("P A R T Y:", response[0].pdE_ID);
        //;
        if (response[0].pdE_ID) {
          toast.success("updated");
          await dispatch(nextStep());
          await dispatch(completeStep({ step: 3, completed: true }));
          if (appointmentType === "P") {
            navigate("/OnlinePayment");
          } else {
            navigate("/UploadDocument");
          }
        } else {
          toast.error("Error Saving PartyDetails");
        }

        // if (appointmentType) {
        //   const response = await dispatch(
        //     ModifyPartyDetailsPaperless(partyDetails)
        //   ).unwrap();
        //   //console.log("P A R T Y:", response[0].pdE_ID);
        //   //;
        //   if (response[0].pdE_ID) {
        //     toast.success("updated");
        //     await dispatch(nextStep());
        //     await dispatch(completeStep({ step: 3, completed: true }));
        //     navigate("/OnlinePayment");
        //   } else {
        //     toast.error("Error Saving PartyDetails");
        //   }
        // } else {
        //   const response = await dispatch(
        //     ModifyPartyDetails(partyDetails)
        //   ).unwrap();
        //   //console.log("P A R T Y:", response[0].pdE_ID);
        //   //;
        //   if (response[0].pdE_ID) {
        //     toast.success("updated");
        //     await dispatch(nextStep());
        //     await dispatch(completeStep({ step: 3, completed: true }));
        //     navigate("/OnlinePayment");
        //   } else {
        //     toast.error("Error Saving PartyDetails");
        //   }
        //}
      }
    } catch (error) {
      console.error("Error updating party details:", error);
      toast.error("Failed to update party details. Please try again.");
    }
  };

  const filteredIdTypeData =
    appointmentType === "V"
      ? idTypeData.filter(
          (option) => option.iD_CODE === "00" || option.iD_CODE === "04"
        ) // Only ADHAAR
      : idTypeData;

  const regexPatterns = {
    "01": /^[A-Z]{3}[0-9]{7}$/, // VOTER ID: Example: ABC1234567
    "02": /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, // PAN CARD: Example: ABCDE1234F
    "03": /^[A-Z]{2}[0-9]{13}$/, // DL: Example: DL0123456789123
    "04": /^[0-9]{12}$/, // ADHAAR: Example: 123456789012
  };

  const handleIDNoChange = (e) => {
    const value = e.target.value.toUpperCase();

    const pattern = regexPatterns[identificationType];
    if (pattern && !pattern.test(value)) {
      setError("Invalid ID No. for " + idName);
    } else {
      setError("");
    }
    setIDNo(value);
  };
  const handleRadioChange = (event) => {
    const value = event.target.value;
    setIsPartySignUpModify(false);
    setConfirmed(value); // Update confirmed state
    dispatch(clearAadhaarDetails());
  };

  useEffect(() => {
    if (confirmed === "no" && !PartySignUpDetails) {
      dispatch(setConfirmedNo());
      dispatch(resetPartySignUpDetails());
      setIsSignUpModalOpen(true); // Open the sign-up modal when confirmed is "no"
      setIsMobileModalOpen(false);
    } else if (confirmed === "yes" && isMobileVerified === false) {
      dispatch(setConfirmedYes());
      dispatch(resetPartySignUpDetails());
      setIsMobileModalOpen(true);
      setIsSignUpModalOpen(false); // Open the mobile verification modal if mobile is not verified
    } else if (confirmed === "yes" && isMobileVerified === true) {
      dispatch(resetPartySignUpDetails());
      setIsMobileModalOpen(false);
    } else {
      setIsMobileModalOpen(false);
    }
  }, [confirmed, isMobileVerified]);

  // trial for refresh before save button and show yes or no radio buttons starts

  useEffect(() => {
    const storedEntries = sessionStorage.getItem("datatableEntriesWitness");

    if (storedEntries) {
      const parsedEntries = JSON.parse(storedEntries);

      // Check if a specific entry is present
      const isEntryPresent = parsedEntries.some(
        (entry) => entry.mobile_No === Mobile
      );

      if (isEntryPresent) {
        setDatatableEntriesWitness(parsedEntries);
      } else {
        resetFormAndShowConfirmation();
      }
    } else {
      resetFormAndShowConfirmation();
    }
  }, []);

  const resetFormAndShowConfirmation = () => {
    dispatch(setisMobileVerified(false));
    dispatch(clearAadhaarDetails());
    dispatch(resetPartySignUpDetails());

    setConfirmed(null); // Show confirmation message
  };

  // trial for refresh before save button and show yes or no radio buttons ends

  return (
    <>
      {/* {confirmed === null && !(isMobileVerified || aadhaarDetails) && ( */}
      {/* {!isEditMode &&
        (confirmed === null || confirmedSlice === null) &&
        (isMobileVerified === false ||
          !PartySignUpDetails ||
          datatableEntriesWitness === 0) && ( */}
      {!isEditMode && confirmed === null && !PartySignUpDetails && (
        <div className="flex justify-center items-center py-10 gap-16 3xl:gap-28">
          <div className="confirmation-message bg-[#E8EFF2] p-6 rounded-md shadow-md text-center w-96 3xl:w-1/3 3xl:h-36">
            <p className="text-md font-semibold mt-4">
              Is User Already Registered With UK PDE???
            </p>
            <div className="flex justify-center mt-6 gap-4">
              <label className="flex items-center">
                <input
                  type="radio"
                  name="confirmation"
                  value="yes"
                  className="mr-2"
                  onChange={handleRadioChange}
                />
                Yes
              </label>
              <label className="flex items-center">
                <input
                  type="radio"
                  name="confirmation"
                  value="no"
                  className="mr-2"
                  onChange={handleRadioChange}
                />
                No
              </label>
            </div>
          </div>
          <div className="ml-10">
            <img
              src={partydetailsimg}
              alt="Illustration"
              className="h-64 3xl:h-80"
            />
          </div>
        </div>
      )}

      {/* {isSignUpModalOpen && confirmed !== null && (
        <PartySignUpModal
          isOpen={isSignUpModalOpen}
          onClose={() => {
            setIsSignUpModalOpen(false);
          }}
          isPartySignUpModify={isPartySignUpModify}
          setIsPartySignUpModify={setIsPartySignUpModify}
        />
      )} */}
      {isSignUpModalOpen && confirmed !== null && (
        <PartySignUpModal
          isOpen={isSignUpModalOpen}
          onClose={() => {
            setIsSignUpModalOpen(false);
            setReEkyc(false);
          }}
          isPartySignUpModify={isPartySignUpModify}
          reEkyc={reEkyc}
          setIsPartySignUpModify={setIsPartySignUpModify}
        />
      )}

      {/* Render MobileModal when the modal state is true */}
      {isMobileModalOpen && (
        <MobileModal
          isOpen={isMobileModalOpen}
          onClose={() => setIsMobileModalOpen(false)}
          activeTab={"witness"}
          // onSuccess={({ regRadio, Reg_Code }) => {
          //   console.log("Received from modal:");
          //   console.log("Selected Option:", regRadio);
          //   console.log("Selected Code:", Reg_Code);
          // }}
          // onSuccess={handleMobileVerificationSuccess}
        />
      )}

      {isPhotoVisible && Photo ? (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center backdrop-blur-md"
          onClick={() => setIsPhotoVisible(false)}
        >
          <div className="w-48 h-48 rounded-full overflow-hidden border-4 border-white shadow-lg bg-white">
            <img
              src={`data:image/jpeg;base64,${Photo}`}
              // src={
              //   PartySignUpDetails[0]?.Photo
              //     ? `data:image/jpeg;base64,${PartySignUpDetails[0]?.Photo}`
              //     : "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
              // }
              alt="User Photo"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      ) : (
        <>
          {((confirmed === "yes" &&
            isMobileVerified &&
            (appointmentType === "P" ||
              (appointmentType === "V" && adhaarEkyc === "Y") ||
              appointmentType === "L")) ||
            (confirmedSlice === null &&
              (isMobileVerified || PartySignUpDetails)) ||
            (confirmed === "no" && PartySignUpDetails) ||
            isEditMode) && (
            <form onSubmit={handleAdd}>
              <div className="grid gap-4 m-8 sm:grid-cols-12 grid-cols-2 items-center">
                <label className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1">
                  ID Type:
                </label>
                <div className="block w-full relative sm:col-span-3 grid-cols-1">
                  <select
                    name="identificationType"
                    value={identificationType}
                    disabled
                    // onChange={(e) => setIdentificationType(e.target.value)}
                    onChange={(e) => {
                      const selectedOption = filteredIdTypeData.find(
                        (option) => option.iD_CODE === e.target.value
                      );
                      setIdentificationType(e.target.value);
                      setidName(selectedOption.id); // Set name to the selected option's id
                      setError(""); // Clear any previous errors when ID type changes
                      setIDNo("");
                      resetFields();
                    }}
                    required
                    className="block w-full pl-2 pr-8 py-1.5 border-none bg-gray-100 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  >
                    {/* <option value="">Select</option> */}
                    {filteredIdTypeData.map((option) => (
                      <option key={option.iD_CODE} value={option.iD_CODE}>
                        {option.id}
                      </option>
                    ))}
                  </select>
                  <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                </div>

                <label className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1">
                  ID No.:
                </label>
                <div className="block w-full relative sm:col-span-3 grid-cols-1">
                  <input
                    type="IDNo"
                    id="IDNo"
                    name="IDNo"
                    value={IDNo}
                    disabled
                    onChange={handleIDNoChange}
                    className="uppercase block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                    required
                  />
                  <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />

                  {error && (
                    <p className="text-red-500 text-xs mt-2 absolute">
                      {error}
                    </p>
                  )}
                </div>
                {identificationType === "04" && (
                  <div className="block w-full relative sm:col-span-3 grid-cols-1">
                    <span
                      onClick={handelReEkyc}
                      className="text-black font-semibold"
                    >
                      Re-Ekyc?
                    </span>
                  </div>
                )}
              </div>

              <div className="grid gap-4 m-8 sm:grid-cols-12 grid-cols-2 items-center">
                <label className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1">
                  Name:
                </label>
                <div className="block w-full relative sm:col-span-3 grid-cols-1">
                  <input
                    type="Name"
                    id="Name"
                    name="Name"
                    value={Name}
                    onChange={handleNameChange}
                    className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                    required
                    disabled={identificationType === "04"}
                  />
                  <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                </div>

                <label className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1">
                  नाम:
                </label>
                <div className="block w-full relative sm:col-span-3 grid-cols-1">
                  <input
                    type="HindiName"
                    id="HindiName"
                    name="HindiName"
                    value={HindiName}
                    // onChange={(e) => setHindiName(e.target.value)}
                    // onChange={(e) => {
                    //   const filtered = e.target.value.replace(
                    //     /[^\u0900-\u097F\s]/g,
                    //     ""
                    //   );
                    //   setHindiName(filtered);
                    // }}
                    onChange={(e) => {
                      const raw = e.target.value;
                      const filtered = raw
                        .replace(/[^\u0900-\u097F\s]/g, "")
                        .trimStart();
                      setHindiName(filtered.replace(/\s+/g, " ").trim());
                    }}
                    className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                    required
                    // disabled={identificationType === "04" && aadhaarDetails}
                  />
                  <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                </div>

                <label className="block w-full relative text-sm font-semibold sm:col-span-1">
                  Relation:
                </label>
                <div className="block w-full relative sm:col-span-3">
                  <select
                    name="Relation"
                    value={relation}
                    onChange={(e) => setRelation(e.target.value)}
                    required
                    disabled={identificationType === "04"}
                    className="block w-full pl-2 pr-8 py-1.5 border-none bg-gray-100 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  >
                    {relationData.map((option) => (
                      <option
                        key={option.relatioN_CODE}
                        value={option.relatioN_CODE}
                      >
                        {option.relation}
                      </option>
                    ))}
                  </select>
                  <hr className="absolute left-0  bottom-0 w-full h-0.5 border-none bg-gray-500" />
                </div>
              </div>
              <div className="grid gap-4 m-8 sm:grid-cols-12 grid-cols-2 items-center">
                <label className="block w-full relative text-sm font-semibold sm:col-span-1">
                  Relative Name:
                </label>
                <div className="block w-full relative sm:col-span-3">
                  <input
                    type="text"
                    id="Relative"
                    name="Relative"
                    value={Relative}
                    onChange={handleRelativeChange}
                    disabled={identificationType === "04"}
                    className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                    required
                  />
                  <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                </div>

                <label className="block w-full relative text-sm font-semibold sm:col-span-1">
                  रिश्तेदार:
                </label>
                <div className="block w-full relative sm:col-span-3">
                  <input
                    type="text"
                    id="RelativeHindi"
                    name="RelativeHindi"
                    value={RelativeHindi}
                    onChange={(e) => {
                      const filtered = e.target.value.replace(
                        /[^\u0900-\u097F\s]/g,
                        ""
                      );
                      setRelativeHindi(filtered);
                    }}
                    className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                    required
                  />
                  <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                </div>
                <label className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1">
                  Gender:
                </label>
                <div className="block w-full relative sm:col-span-3 grid-cols-1">
                  <select
                    name="Gender"
                    value={Gender}
                    onChange={handleGenderChange}
                    disabled={identificationType === "04"}
                    required
                    className="block w-full pl-2 pr-8 py-1.5 border-none bg-gray-100 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  >
                    {Array.isArray(genderData) &&
                      genderData.map((option) => (
                        <option
                          key={option.gendeR_CODE}
                          value={option.gendeR_CODE}
                        >
                          {option.gender}
                        </option>
                      ))}
                  </select>
                  <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                </div>
              </div>
              <div className="grid gap-4 m-8 sm:grid-cols-12 grid-cols-2 items-center">
                <label className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1">
                  Occupation:
                </label>
                <div className="block w-full relative sm:col-span-3 grid-cols-1">
                  <select
                    name="Occupation"
                    value={Occupation}
                    // onChange={(e) => setOccupation(e.target.value)}
                    onChange={(e) => {
                      const selectedOption = occupationData.find(
                        (option) => option.occupatioN_CODE === e.target.value
                      );
                      setOccupation(e.target.value);
                      setoccupationName(selectedOption.occupation); // Set name to the selected option's id
                    }}
                    required
                    className="block w-full pl-2 pr-8 py-1.5 border-none bg-gray-100 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  >
                    {/* <option value="">Mode Of Payment</option> */}
                    {occupationData.map((option) => (
                      <option
                        key={option.occupatioN_CODE}
                        value={option.occupatioN_CODE}
                      >
                        {option.occupation}
                      </option>
                    ))}
                  </select>
                  <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                </div>

                <label className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1">
                  Mobile No:
                </label>
                <div className="block w-full relative sm:col-span-3 grid-cols-1">
                  <input
                    type="text"
                    id="Mobile"
                    name="Mobile"
                    value={Mobile}
                    maxLength={10}
                    // onChange={(e) => setMobile(e.target.value)}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only digits and limit to 10 characters
                      if (/^\d*$/.test(value) && value.length <= 10) {
                        setMobile(value);
                      }
                    }}
                    className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                    required
                  />
                  <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                </div>
                <label className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1">
                  D.O.B
                </label>
                <div className="block w-full relative sm:col-span-3 grid-cols-1">
                  <input
                    type="date"
                    name="selectedDate"
                    placeholder="MM/DD/YYYY"
                    value={
                      selectedDate
                        ? selectedDate.toISOString().split("T")[0]
                        : ""
                    }
                    onChange={(e) => setSelectedDate(new Date(e.target.value))}
                    className="block w-full pl-2 pr-8 py-1.5 border-none bg-gray-100 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    required
                  />
                  <hr className="absolute left-0 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                </div>
              </div>
              <div className="grid gap-4 m-8 sm:grid-cols-12 grid-cols-2 items-center">
                <label className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1">
                  Email:
                </label>
                <div className="block w-full relative sm:col-span-3 grid-cols-1">
                  <input
                    type="Email"
                    id="Email"
                    Email="Email"
                    value={Email}
                    placeholder="abc@example.com"
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only digits and limit to 10 characters
                      if (/^[a-zA-Z0-9]+@(?:[a-zA-Z0-9]+\.)+[A-Za-z]+$/) {
                        setEmail(value);
                      }
                    }}
                    className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                    required
                    // disabled={identificationType === "04"}
                  />
                  <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                </div>
                <span
                  onClick={() => setIsPhotoVisible(true)}
                  className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1 text-blue-300"
                >
                  View Photo
                </span>{" "}
                <div className="block w-full relative sm:col-span-3 grid-cols-1"></div>
                <label className="block w-full relative text-sm font-semibold sm:col-span-1"></label>
                <div className="block w-full relative sm:col-span-3"></div>
              </div>

              <div className="grid gap-2 m-8 sm:grid-cols-11 items-center">
                <label className="block w-full relative text-sm font-semibold sm:col-span-1">
                  Address:
                </label>

                {[
                  { id: "HouseNo", value: HouseNo, setValue: setHouseNo },
                  { id: "Locality", value: Locality, setValue: setLocality },
                  { id: "Area", value: Area, setValue: setArea },
                ].map(({ id, value, setValue }) => (
                  <div key={id} className="block w-full relative sm:col-span-3">
                    <label
                      htmlFor={id}
                      className="absolute left-4 -top-2.5 text-gray-400 text-sm font-serif px-1"
                    >
                      {id}
                    </label>
                    <input
                      type="text"
                      id={id}
                      name={id}
                      value={value}
                      onChange={(e) => setValue(e.target.value)}
                      disabled={identificationType === "04"}
                      className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                      required
                    />
                    <hr className="absolute left-0 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                  </div>
                ))}
              </div>

              <div className="grid gap-2 m-8 sm:grid-cols-11 items-center">
                <label className="block w-full relative text-sm font-semibold sm:col-span-1"></label>

                {[
                  {
                    id: "State",
                    value: State,
                    onChange: handleStateChange,
                    options: stateOptions,
                  },
                  {
                    id: "District",
                    value: district,
                    onChange: handleDistrictChange,
                    options: districtOptions,
                  },
                ].map(({ id, value, onChange, options }) => (
                  <div key={id} className="block w-full relative sm:col-span-3">
                    <label
                      htmlFor={id}
                      className="absolute left-4 -top-2.5 text-gray-400 text-sm font-serif px-1"
                    >
                      {id}
                    </label>
                    <select
                      id={id}
                      className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                      value={value}
                      onChange={onChange}
                      required
                    >
                      <option value="">{id}</option>
                      {options.map((option) => (
                        <option
                          key={option[`${id.toLowerCase()}ID`]}
                          value={option[`${id.toLowerCase()}ID`]}
                        >
                          {option[`${id.toLowerCase()}Name`]}
                        </option>
                      ))}
                    </select>
                    <hr className="absolute left-0 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                  </div>
                ))}

                <div className="block w-full relative sm:col-span-3">
                  <label
                    htmlFor="Pincode"
                    className="absolute left-4 -top-2.5 text-gray-400 text-sm font-serif px-1"
                  >
                    Pincode
                  </label>
                  <input
                    type="tel"
                    id="Pincode"
                    name="Pincode"
                    placeholder="Pincode"
                    value={Pincode}
                    maxLength={6}
                    minLength={6}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d{0,6}$/.test(value)) {
                        setPincode(value);
                      }
                    }}
                    disabled={identificationType === "04"}
                    className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                    required
                  />
                  <hr className="absolute left-0 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                </div>
              </div>
            </form>
          )}
        </>
      )}

      {/* Add & Save Buttons */}
      <div className="flex justify-center mt-5 gap-4">
        <button
          className="px-6 py-1.5 m-2 bg-blue-500 text-white rounded-full text-md"
          onClick={handleAdd}
          type="submit"
        >
          Add
        </button>

        <button
          type="button"
          className="px-6 py-1.5 m-2 bg-blue-500 text-white rounded-full text-md"
          onClick={isModifying ? handleUpdate : handleSave}
        >
          {isModifying ? "Update" : "Save"}
        </button>
      </div>

      <div className="flex justify-center m-3 gap-4">
        <Datatable
          entries={datatableEntriesWitness}
          onDelete={handleDelete}
          onEdit={handleEdit}
          appointmentType={appointmentType}
          activeTab={"witness"}
        />
      </div>
      <AadhaarOTPModal
        isOpen={showOtpForm}
        onClose={() => setShowOtpForm(false)}
      />
    </>
  );
};

export default PartyDetails;
